class ProductEstimator {
  constructor(productElement, index) {
  this.productElement = productElement;
  this.index = index;
  this.tabs = productElement.querySelectorAll('.estimator-tab');
  this.currentTab = 0;
  this.recapBox = productElement.querySelector(`#recap-${index}`);
  this.recapContent = this.recapBox?.querySelector('.recap-content');
  
  // GENERA ID UNIVOCO BASATO SU PRODUCT + VARIANT + UNIT INDEX
  this.uniqueProductId = this.getUniqueProductId();
  
  console.log('Initializing product with unique ID:', this.uniqueProductId);

  // Setup arredo PRIMA di caricare i dati
  this.setupArredoEsterno();
  
  // CORREZIONE: Setup colori PRIMA di caricare i dati
  this.setupAdvancedColorSelection();
  
  // Carica i dati salvati per questo prodotto specifico
  this.loadSavedData();

    setTimeout(() => {
    this.setupConsegnaOptions();
    this.setupMontaggioOptions();
  }, 200);
  
  this.init();
}

updateTabsList() {
  this.tabs = this.productElement.querySelectorAll('.estimator-tab');
  console.log('📋 Tab aggiornate:', this.tabs.length, 'tab trovate');
}

  // ---------------- GESTIONE BARRA DI PROGRESSO ----------------
  setupProgressBar() {
    this.initializeProgressBar();
    
    // Aggiorna la barra quando cambia tab
    this.productElement.addEventListener('tabChanged', () => {
      this.updateProgressBar();
    });
  }

  initializeProgressBar() {
  const visibleTabs = this.getVisibleTabs();
  const progressSteps = this.productElement.querySelector(`#progress-steps-${this.index}`);
  
  if (progressSteps) {
    progressSteps.innerHTML = '';
    
    visibleTabs.forEach((tab, index) => {
      const step = document.createElement('div');
      step.className = 'progress-step';
      step.textContent = (index + 1).toString();
      progressSteps.appendChild(step);
    });
  }
  
  this.updateProgressBar();
}

updateProgressBar() {
  const progressFill = this.productElement.querySelector(`#progress-fill-${this.index}`);
  const progressStats = this.productElement.querySelector(`#progress-stats-${this.index}`);
  const progressSteps = this.productElement.querySelector(`#progress-steps-${this.index}`);
  
  if (!progressFill || !progressStats) {
    console.error('Elementi barra progresso non trovati per:', this.index);
    return;
  }
  
  const visibleTabs = this.getVisibleTabs();
  const completedTabs = this.getCompletedTabsCount();
  const totalTabs = visibleTabs.length;
  const progressPercent = totalTabs > 0 ? (completedTabs / totalTabs) * 100 : 0;
  
  console.log(`🔄 Aggiornamento barra ${this.index}:`, {
    completati: completedTabs,
    totali: totalTabs,
    percentuale: progressPercent,
    visibleTabs: visibleTabs.length,
    currentTab: this.currentTab
  });
  
  // Aggiorna barra e statistiche
  progressFill.style.width = `${progressPercent}%`;
  progressStats.textContent = `${completedTabs}/${totalTabs} completate`;
  
  // Aggiorna indicatori dei passi
  this.updateProgressSteps(completedTabs, progressSteps);
  
  // DEBUG: Forza il reflow per assicurarsi che l'animazione venga visualizzata
  progressFill.offsetHeight;
}


getCompletedTabsCount() {
  const visibleTabs = this.getVisibleTabs();
  const currentVisibleIndex = visibleTabs.findIndex(tab => 
    tab.classList.contains('active')
  );
  
  // I tab completati sono tutti quelli PRIMA di quello corrente
  let completedCount = Math.max(0, currentVisibleIndex);
  
  // Se il prodotto è completato (siamo nel recap), considera tutto completato
  if (this.productElement.classList.contains('completed')) {
    completedCount = visibleTabs.length;
  }
  
  return completedCount;
}

updateProgressSteps(completedCount, progressStepsContainer) {
  if (!progressStepsContainer) return;
  
  const steps = progressStepsContainer.querySelectorAll('.progress-step');
  
  steps.forEach((step, index) => {
    step.classList.remove('completed', 'active');
    
    if (index < completedCount) {
      // Tab completati
      step.classList.add('completed');
    } else if (index === completedCount) {
      // Tab corrente
      step.classList.add('active');
    }
    // I tab futuri rimangono con lo stile base
  });
}

      // Modifica showTab per triggerare l'evento
showTab(index) {
  console.log('🎯 Showing tab:', index, 'of', this.tabs.length);
  
  // NASCONDI TUTTE LE TAB
  this.tabs.forEach(tab => {
    tab.classList.remove('active');
    tab.style.display = 'none';
  });

  // MOSTRA SOLO LA TAB CORRENTE SE È VISIBILE
  if (this.tabs[index] && this.isTabVisible(this.tabs[index])) {
    this.tabs[index].classList.add('active');
    this.tabs[index].style.display = 'block';
    
    console.log('✅ Tab mostrata:', this.tabs[index].dataset.tab);
    
    // Aggiorna i suggerimenti foto quando si mostra la tab foto
    if (this.tabs[index].dataset.tab.includes('photos')) {
      this.updatePhotoSuggestions();
    }
  } else {
    // Se la tab corrente non è visibile, trova la prossima tab visibile
    console.log('❌ Tab non visibile, cercando prossima...');
    this.findAndShowNextVisibleTab(index);
    return;
  }

  this.updateNavigation();
  
  // AGGIORNA SEMPRE LA BARRA DI PROGRESSO
  console.log('📊 Aggiornamento barra da showTab');
  this.updateProgressBar();
}
  
  // ---------------- OTTIENI ID UNIVOCO DEL PRODOTTO ----------------
  getUniqueProductId() {
    // Cerca l'input product_id
    const productIdInput = this.productElement.querySelector('input[name*="product_id"]');
    const productId = productIdInput ? productIdInput.value : 'unknown';
    
    // Cerca l'input variant_id se esiste
    const variantIdInput = this.productElement.querySelector('input[name*="variant_id"]');
    const variantId = variantIdInput ? variantIdInput.value : 'default';
    
    // Determina l'indice dell'unità per questo product_variant
    const unitIndex = this.getUnitIndexForProductVariant(productId, variantId);
    
    return `product_${productId}_variant_${variantId}_unita${unitIndex}`;
  }

  // ---------------- DETERMINA L'INDICE DELL'UNITÀ ----------------
  getUnitIndexForProductVariant(productId, variantId) {
    const productVariantKey = `product_${productId}_variant_${variantId}`;
    const allProducts = document.querySelectorAll('.estimator__product');
    let unitCounter = 1;
    
    // Conta quante unità dello stesso product_variant ci sono prima di questa
    for (let i = 0; i < allProducts.length; i++) {
      const prod = allProducts[i];
      const prodIdInput = prod.querySelector('input[name*="product_id"]');
      const varIdInput = prod.querySelector('input[name*="variant_id"]');
      
      if (prodIdInput && varIdInput) {
        const prodId = prodIdInput.value;
        const varId = varIdInput.value;
        
        // Se troviamo lo stesso product_variant
        if (prodId === productId && varId === variantId) {
          // Se è l'elemento corrente, restituisci il counter
          if (prod === this.productElement) {
            return unitCounter;
          }
          unitCounter++;
        }
      }
    }
    
    return unitCounter;
  }


  // ---------------- SETUP SIDE CLOSURES COMPLETO ----------------
setupSideClosures() {
  const sideClosuresTab = this.productElement.querySelector('[data-tab^="side-closures-"]');
  if (!sideClosuresTab) return;

  this.setupClosureToggle();
  this.setupSideButtons();
  this.setupMeasuresListener();

  // AGGIUNTO: Aggiorna su resize della finestra
  window.addEventListener('resize', () => {
    if (sideClosuresTab.style.display !== 'none') {
      setTimeout(() => {
        this.updatePergolaSVG();
      }, 100);
    }
  });
  
  // AGGIUNTO: Aggiorna stato pulsanti all'inizializzazione
  setTimeout(() => {
    this.updateSideButtonsState();
  }, 100);
  
  // Inizializza SVG quando la tab diventa attiva
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        if (sideClosuresTab.style.display !== 'none') {
          setTimeout(() => {
            this.initializePergolaSVG();
            this.updateSideButtonsState(); // AGGIUNTO
          }, 100);
        }
      }
    });
  });
  
  observer.observe(sideClosuresTab, { attributes: true });
  
  // Anche al click sui pulsanti di navigazione
  this.productElement.querySelectorAll('.next-tab, .prev-tab').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => {
        if (sideClosuresTab.style.display !== 'none') {
          this.updatePergolaSVG();
          this.updateSideButtonsState(); // AGGIUNTO
        }
      }, 200);
    });
  });

  // AGGIUNTO: Aggiorna stato pulsanti quando cambia il tipo di struttura
  const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
  if (structureSelect) {
    structureSelect.addEventListener('change', () => {
      setTimeout(() => {
        this.updateSideButtonsState();
        this.updatePergolaSVG();
      }, 100);
    });
  }
}

// ---------------- GESTIONE CHIUSURE LATERALI PER PERGOLE (BLOCCHI SVG COMPLETI) ----------------

/* Assicurati che nel markup esista un container dove appendere l'SVG, ad es:
   <div class="pergola-preview" data-index="..."><svg></svg></div>
   Il codice creerà l'<svg> se non esiste. */

setupSideButtons() {
  const closureButtons = this.productElement.querySelectorAll('.closure-btn');
  const configInput = this.productElement.querySelector('input[name*="[Configurazione_Chiusure]"]');

  closureButtons.forEach(button => {
    button.addEventListener('click', () => {
      const side = button.dataset.side;
      const value = button.dataset.value;
      
      // CONTROLLO: Se è addossata e si sta cercando di selezionare il lato 1, blocca
      const pergolaType = this.getPergolaType();
      if (side === 'lato1' && pergolaType.mount === 'addossata') {
        alert('Il lato 1 non può avere chiusure quando la struttura è addossata al muro');
        return;
      }
      
      // Rimuovi active da tutti i pulsanti dello stesso lato
      const sameSideButtons = this.productElement.querySelectorAll(`.closure-btn[data-side="${side}"]`);
      sameSideButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.style.borderColor = '#e0e0e0';
        btn.style.background = 'white';
      });
      
      // Imposta active sul pulsante cliccato
      button.classList.add('active');
      button.style.borderColor = '#c68c4c';
      button.style.background = '#fff8f0';
      
      this.updatePergolaSVG();
      this.saveClosureConfiguration();
      this.updateSideButtonsState(); // AGGIUNTO
    });
  });
}

setupMeasuresListener() {
  const widthInput = this.productElement.querySelector('#width-' + this.index + '-1');
  const protrusionInput = this.productElement.querySelector('#protrusion-' + this.index + '-1');
  
  if (widthInput && protrusionInput) {
    const updateSVG = () => {
      // chiamiamo sempre anche se sono 0 per forzare re-render pulito
      this.updatePergolaSVG();
    };
    
    widthInput.addEventListener('input', updateSVG);
    protrusionInput.addEventListener('input', updateSVG);
    widthInput.addEventListener('change', updateSVG);
    protrusionInput.addEventListener('change', updateSVG);
  }
}

setupClosureToggle() {
  const toggleOptions = this.productElement.querySelectorAll('.toggle-option');
  const configurationSection = this.productElement.querySelector('.closure-configuration');
  const hiddenInput = this.productElement.querySelector('input[name*="[Chiusure_Laterali]"]');
  const configInput = this.productElement.querySelector('input[name*="[Configurazione_Chiusure]"]');

  toggleOptions.forEach(option => {
    const button = option.querySelector('.toggle-btn');
    const value = option.dataset.value;

    button.addEventListener('click', () => {
      // Rimuovi active da tutti i pulsanti
      toggleOptions.forEach(opt => {
        const btn = opt.querySelector('.toggle-btn');
        btn.classList.remove('active');
        btn.style.borderColor = '#e0e0e0';
        btn.style.background = 'white';
      });

      // Imposta active sul pulsante cliccato
      button.classList.add('active');
      button.style.borderColor = '#c68c4c';
      button.style.background = '#fff8f0';

      // Mostra/nascondi configurazione
      if (value === 'si') {
        configurationSection.style.display = 'block';
        hiddenInput.value = 'si';
        
        // AGGIUNTO: Se c'è una configurazione salvata, ripristinala
        if (configInput && configInput.value) {
          try {
            const savedConfig = JSON.parse(configInput.value);
            console.log('Ripristino configurazione salvata:', savedConfig);
            
            // Ripristina i pulsanti dalla configurazione salvata
            Object.keys(savedConfig).forEach(side => {
              const savedValue = savedConfig[side];
              const savedButton = this.productElement.querySelector(`.closure-btn[data-side="${side}"][data-value="${savedValue}"]`);
              if (savedButton) {
                const sameSideButtons = this.productElement.querySelectorAll(`.closure-btn[data-side="${side}"]`);
                sameSideButtons.forEach(btn => {
                  btn.classList.remove('active');
                  btn.style.borderColor = '#e0e0e0';
                  btn.style.background = 'white';
                });
                
                savedButton.classList.add('active');
                savedButton.style.borderColor = '#c68c4c';
                savedButton.style.background = '#fff8f0';
              }
            });
            
            this.updateSideButtonsState();
          } catch (error) {
            console.error('Errore nel ripristino configurazione:', error);
          }
        }
        
        this.updatePergolaSVG(); // Aggiorna SVG quando si attiva
      } else {
        configurationSection.style.display = 'none';
        hiddenInput.value = 'no';
        // NON cancellare configInput.value per preservare i dati
        //this.resetSideSelection();
      }

      this.saveData();
    });
  });
}


initializePergolaSVG() {
  const svgContainer = this.productElement.querySelector(`#pergola-svg-container-${this.index}`);
  if (!svgContainer) {
    console.error('Container SVG non trovato per:', this.index);
    return;
  }

  let svgElement = this.productElement.querySelector(`#pergola-svg-${this.index}`);
  if (!svgElement) {
    svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgElement.setAttribute('id', `pergola-svg-${this.index}`);
    svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svgElement.style.border = '1px solid #e0e0e0';
    svgElement.style.background = '#f9f9f9';
    svgElement.style.display = 'block';
    svgContainer.appendChild(svgElement);
  }
  
  // Forza l'aggiornamento iniziale
  this.updatePergolaSVG();
}

getPergolaDimensions() {
  const widthInput = this.productElement.querySelector('#width-' + this.index + '-1');
  const protrusionInput = this.productElement.querySelector('#protrusion-' + this.index + '-1');
  
  let wRaw = parseInt(widthInput?.value) || 0;
  let hRaw = parseInt(protrusionInput?.value) || 0;

  console.log('Misure originali:', wRaw, 'x', hRaw);

  // SE le misure sono 0, NON usare default ma mostra messaggio
  if (wRaw === 0 || hRaw === 0) {
    console.log('Misure non inserite, usando placeholder');
    return { 
      width: this.isMobile() ? 176 : 350, // Ridotto da 280 a 220
      height: this.isMobile() ? 128 : 250, // Ridotto da 200 a 160
      originalWidth: wRaw, 
      originalHeight: hRaw,
      ratio: 1.4,
      hasValidDimensions: false
    };
  }

  const ratio = wRaw / hRaw;
  let width, height;
  
  // Dimensioni massime per il preview - ULTERIORMENTE RIDOTTE PER MOBILE
  const maxWidth = this.isMobile() ? 176 : 400; // Ridotto da 280 a 220
  const maxHeight = this.isMobile() ? 128 : 300; // Ridotto da 200 a 160
  
  // Calcola dimensioni mantenendo le proporzioni REALI
  if (ratio > 1) {
    // Larghezza > Altezza (struttura orizzontale)
    width = maxWidth;
    height = Math.max(this.isMobile() ? 100 : 150, Math.round(maxWidth / ratio)); // Ridotto da 120 a 100
    
    if (height > maxHeight) {
      height = maxHeight;
      width = Math.round(maxHeight * ratio);
    }
  } else {
    // Altezza >= Larghezza (struttura verticale)
    height = maxHeight;
    width = Math.max(this.isMobile() ? 120 : 200, Math.round(maxHeight * ratio)); // Ridotto da 150 a 120
    
    if (width > maxWidth) {
      width = maxWidth;
      height = Math.round(maxWidth / ratio);
    }
  }
  
  const result = { 
    width: Math.min(width, maxWidth), 
    height: Math.min(height, maxHeight), 
    originalWidth: wRaw, 
    originalHeight: hRaw,
    ratio: ratio,
    hasValidDimensions: true
  };
  
  console.log('Dimensioni calcolate per SVG:', result, 'Mobile:', this.isMobile());
  return result;
}

// AGGIUNGI METODO PER RILEVARE MOBILE
isMobile() {
  return window.innerWidth <= 767;
}

getPergolaType() {
  const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
  const structureType = structureSelect ? structureSelect.value : '';
  
  const isAddossata = structureType === 'Addossata';
  const isAutoportante = structureType === 'Autoportante';
  
  // Determina il tipo principale in base ai tag del prodotto
  const tagsInput = this.productElement.querySelector('input[name*="[Tags_Prodotto]"]');
  const tags = (tagsInput ? tagsInput.value.toLowerCase() : '').trim();

  const isPergotenda = tags.includes('pergotenda');
  const isBioclimatica = tags.includes('bioclimatica');
  const isPergola = tags.includes('pergola') || (!isPergotenda && !isBioclimatica && tags.length > 0);

  if (isPergotenda) return { main: 'pergotenda', mount: isAddossata ? 'addossata' : (isAutoportante ? 'autoportante' : 'unknown') };
  if (isBioclimatica) return { main: 'bioclimatica', mount: isAddossata ? 'addossata' : (isAutoportante ? 'autoportante' : 'unknown') };
  if (isPergola) return { main: 'pergola', mount: isAddossata ? 'addossata' : (isAutoportante ? 'autoportante' : 'unknown') };
  return { main: 'generic', mount: 'unknown' };
}

// --- Helper: determina tipo di pergola ---
getPergolaType() {
  const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
  const structureType = structureSelect ? structureSelect.value : '';
  
  const isAddossata = structureType === 'Addossata';
  
  // Determina il tipo principale in base ai tag del prodotto
  const tagsInput = this.productElement.querySelector('input[name*="[Tags_Prodotto]"]');
  const tags = (tagsInput ? tagsInput.value.toLowerCase() : '').trim();

  const isPergotenda = tags.includes('pergotenda');
  const isBioclimatica = tags.includes('bioclimatica');
  const isPergola = tags.includes('pergola') || (!isPergotenda && !isBioclimatica && tags.length > 0);

  if (isPergotenda) return { main: 'pergotenda', mount: isAddossata ? 'addossata' : 'autoportante' };
  if (isBioclimatica) return { main: 'bioclimatica', mount: isAddossata ? 'addossata' : 'autoportante' };
  if (isPergola) return { main: 'pergola', mount: isAddossata ? 'addossata' : 'autoportante' };
  return { main: 'generic', mount: 'autoportante' };
}

// --- Helper: disegna pilastri angolari più realistici ---
drawColumns(svg, frameX, frameY, frameW, frameH) {
  const pergolaType = this.getPergolaType();
  const isAddossata = pergolaType.mount === 'addossata';
  
  const columnSize = 16;
  const columnColor = '#7d7d7d';
  const columnShadow = '#5a5a5a';
  
  // Definisci le posizioni dei pilastri
  const positions = [
    { x: frameX - columnSize/2, y: frameY - columnSize/2, side: 'lato1-lato4' }, // top-left (lato1 + lato4)
    { x: frameX + frameW - columnSize/2, y: frameY - columnSize/2, side: 'lato1-lato2' }, // top-right (lato1 + lato2)
    { x: frameX + frameW - columnSize/2, y: frameY + frameH - columnSize/2, side: 'lato2-lato3' }, // bottom-right (lato2 + lato3)
    { x: frameX - columnSize/2, y: frameY + frameH - columnSize/2, side: 'lato3-lato4' } // bottom-left (lato3 + lato4)
  ];
  
  positions.forEach(pos => {
    // SE è ADDOSSATA, salta i pilastri sul lato 1 (alto)
    if (isAddossata && (pos.side === 'lato1-lato4' || pos.side === 'lato1-lato2')) {
      return;
    }
    
    // Ombreggiatura per effetto 3D
    const shadow = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    shadow.setAttribute('x', pos.x + 2);
    shadow.setAttribute('y', pos.y + 2);
    shadow.setAttribute('width', columnSize);
    shadow.setAttribute('height', columnSize);
    shadow.setAttribute('fill', columnShadow);
    svg.appendChild(shadow);
    
    // Pilastro principale
    const column = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    column.setAttribute('x', pos.x);
    column.setAttribute('y', pos.y);
    column.setAttribute('width', columnSize);
    column.setAttribute('height', columnSize);
    column.setAttribute('fill', columnColor);
    column.setAttribute('stroke', '#5a5a5a');
    column.setAttribute('stroke-width', '1');
    svg.appendChild(column);
  });
}

// --- METODO CORRETTO PER PILASTRI AGGIUNTIVI ---
drawAdditionalColumns(svg, frameX, frameY, frameW, frameH) {
  const pergolaType = this.getPergolaType();
  const { originalWidth, originalHeight } = this.getPergolaDimensions();
  const isAddossata = pergolaType.mount === 'addossata';
  
  // Se le misure non sono valide, non disegnare colonne aggiuntive
  if (!originalWidth || !originalHeight || originalWidth === 0 || originalHeight === 0) {
    return;
  }

  const columnSize = 16;
  const columnColor = '#7d7d7d';
  const columnShadow = '#5a5a5a';

  console.log(`Disegno colonne aggiuntive: ${originalWidth}x${originalHeight}cm, Addossata: ${isAddossata}`);

  // LATO 2 (destro) - sia per addossate che autoportanti
  if (originalWidth > 500) {
    const additionalColumnsCount = Math.floor(originalWidth / 500);
    console.log(`Lato 2 > 500cm, aggiungo ${additionalColumnsCount} colonne`);
    
    for (let i = 1; i <= additionalColumnsCount; i++) {
      const positionRatio = i / (additionalColumnsCount + 1);
      const x = frameX + (frameW * positionRatio) - columnSize/2;
      
      // Colonna in alto a destra (lato 2 superiore) - SOLO se non è addossata
      if (!isAddossata) {
        this.drawSingleColumn(svg, x, frameY - columnSize/2, columnSize, columnColor, columnShadow);
      }
      
      // Colonna in basso a destra (lato 2 inferiore) - SEMPRE
      this.drawSingleColumn(svg, x, frameY + frameH - columnSize/2, columnSize, columnColor, columnShadow);
    }
  }

  // LATO 4 (sinistro) - sia per addossate che autoportanti
  if (originalHeight > 500) {
    const additionalColumnsCount = Math.floor(originalHeight / 500);
    console.log(`Lato 3 > 500cm, aggiungo ${additionalColumnsCount} colonne`);
    
    for (let i = 1; i <= additionalColumnsCount; i++) {
      const positionRatio = i / (additionalColumnsCount + 1);
      const y = frameY + (frameH * positionRatio) - columnSize/2;
      
      
      this.drawSingleColumn(svg, frameX - columnSize/2, y, columnSize, columnColor, columnShadow);
      
      
      // Colonna in basso a destra (lato 3 destro) - SEMPRE
      this.drawSingleColumn(svg, frameX + frameW - columnSize/2, y, columnSize, columnColor, columnShadow);
    }
  }

  // LATO 1 (alto) - SOLO per autoportanti
  if (!isAddossata && originalWidth > 500) {
    const additionalColumnsCount = Math.floor(originalWidth / 500);
    console.log(`Lato 4 > 500cm, aggiungo ${additionalColumnsCount} colonne`);
    
    for (let i = 1; i <= additionalColumnsCount; i++) {
      const positionRatio = i / (additionalColumnsCount + 1);
      const x = frameX + (frameW * positionRatio) - columnSize/2;
      
      // Colonna in alto a sinistra (lato 4 superiore)
      this.drawSingleColumn(svg, x, frameY - columnSize/2, columnSize, columnColor, columnShadow);
      
      // Colonna in basso a sinistra (lato 4 inferiore)
      this.drawSingleColumn(svg, x, frameY + frameH - columnSize/2, columnSize, columnColor, columnShadow);
    }
  }
}

// --- HELPER PER DISEGNARE SINGOLO PILASTRO ---
drawSingleColumn(svg, x, y, size, color, shadowColor) {
  // Ombreggiatura
  const shadow = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  shadow.setAttribute('x', x + 2);
  shadow.setAttribute('y', y + 2);
  shadow.setAttribute('width', size);
  shadow.setAttribute('height', size);
  shadow.setAttribute('fill', shadowColor);
  svg.appendChild(shadow);
  
  // Pilastro principale
  const column = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  column.setAttribute('x', x);
  column.setAttribute('y', y);
  column.setAttribute('width', size);
  column.setAttribute('height', size);
  column.setAttribute('fill', color);
  column.setAttribute('stroke', '#5a5a5a');
  column.setAttribute('stroke-width', '1');
  svg.appendChild(column);
}

// --- Helper: disegna lamelle per pergola bioclimatica (vista dall'alto) ---
drawBioclimaticaLamelles(svg, frameX, frameY, frameW, frameH) {
  const lamelleCount = 12; // Più lamelle per realismo
  const lamelleSpacing = (frameW - 20) / lamelleCount;
  const lamelleColor = '#4a4a4a';
  const lamelleLength = frameH - 20;
  
  for (let i = 0; i < lamelleCount; i++) {
    const x = frameX + 10 + (i * lamelleSpacing);
    
    // Lamella principale
    const lamella = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    lamella.setAttribute('x', x - 1);
    lamella.setAttribute('y', frameY + 10);
    lamella.setAttribute('width', 6);
    lamella.setAttribute('height', lamelleLength);
    lamella.setAttribute('fill', lamelleColor);
    lamella.setAttribute('rx', '1'); // Angoli leggermente arrotondati
    svg.appendChild(lamella);
    
    // Ombreggiatura per effetto 3D
    const shadow = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    shadow.setAttribute('x', x);
    shadow.setAttribute('y', frameY + 10);
    shadow.setAttribute('width', 4);
    shadow.setAttribute('height', lamelleLength);
    shadow.setAttribute('fill', '#2d2d2d');
    shadow.setAttribute('rx', '1');
    svg.appendChild(shadow);
  }
}

// --- Helper: disegna struttura per pergotenda (vista dall'alto) ---
drawPergotendaStructure(svg, frameX, frameY, frameW, frameH) {
  // Traversi principali (più spessi)
  const mainTraversiCount = 3;
  const traversiSpacing = frameW / (mainTraversiCount + 1);
  const traversoColor = '#6b6b6b';
  
  for (let i = 1; i <= mainTraversiCount; i++) {
    const x = frameX + (i * traversiSpacing);
    
    const traverso = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    traverso.setAttribute('x', x - 3);
    traverso.setAttribute('y', frameY + 10);
    traverso.setAttribute('width', 8);
    traverso.setAttribute('height', frameH - 20);
    traverso.setAttribute('fill', traversoColor);
    traverso.setAttribute('rx', '2');
    svg.appendChild(traverso);
  }
  
  // Telo (rappresentato come area semitrasparente)
  const telo = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  telo.setAttribute('x', frameX + 15);
  telo.setAttribute('y', frameY + 15);
  telo.setAttribute('width', frameW - 30);
  telo.setAttribute('height', frameH - 30);
  telo.setAttribute('fill', 'rgba(100, 100, 100, 0.2)');
  telo.setAttribute('stroke', 'rgba(100, 100, 100, 0.3)');
  telo.setAttribute('stroke-width', '1');
  telo.setAttribute('stroke-dasharray', '2,2');
  svg.appendChild(telo);
}

// --- Helper: disegna struttura generica per pergola (vista dall'alto) ---
drawGenericPergola(svg, frameX, frameY, frameW, frameH) {
  // Traversi principali
  const mainTraversiCount = 3;
  const traversiSpacing = frameW / (mainTraversiCount + 1);
  const traversoColor = '#6b6b6b';
  
  for (let i = 1; i <= mainTraversiCount; i++) {
    const x = frameX + (i * traversiSpacing);
    
    const traverso = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    traverso.setAttribute('x', x - 3);
    traverso.setAttribute('y', frameY + 10);
    traverso.setAttribute('width', 6);
    traverso.setAttribute('height', frameH - 20);
    traverso.setAttribute('fill', traversoColor);
    traverso.setAttribute('rx', '1');
    svg.appendChild(traverso);
  }
  
  // Elementi trasversali
  const crossElementsCount = 5;
  const crossSpacing = (frameH - 20) / (crossElementsCount + 1);
  const crossColor = '#8a8a8a';
  
  for (let i = 1; i <= crossElementsCount; i++) {
    const y = frameY + 10 + (i * crossSpacing);
    
    const element = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    element.setAttribute('x', frameX + 10);
    element.setAttribute('y', y - 1);
    element.setAttribute('width', frameW - 20);
    element.setAttribute('height', 3);
    element.setAttribute('fill', crossColor);
    element.setAttribute('rx', '1');
    svg.appendChild(element);
  }
}

// --- Helper: disegna muro addossato (lato 1) ---
drawWall(svg, frameX, frameY, frameW, frameH) {
  const wallThickness = 25;
  const wallColor = '#8c8c8c';
  const wallPattern = '#7a7a7a';
  
  // Muro principale
  const wall = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  wall.setAttribute('x', frameX);
  wall.setAttribute('y', frameY - wallThickness);
  wall.setAttribute('width', frameW);
  wall.setAttribute('height', wallThickness);
  wall.setAttribute('fill', wallColor);
  wall.setAttribute('stroke', '#6a6a6a');
  wall.setAttribute('stroke-width', '2');
  svg.appendChild(wall);

  // Pattern del muro (linee orizzontali per effetto mattoni)
  for (let i = 1; i < 4; i++) {
    const lineY = frameY - wallThickness + (i * (wallThickness / 4));
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', frameX);
    line.setAttribute('y1', lineY);
    line.setAttribute('x2', frameX + frameW);
    line.setAttribute('y2', lineY);
    line.setAttribute('stroke', wallPattern);
    line.setAttribute('stroke-width', '1');
    svg.appendChild(line);
  }

  // Testo "PARETE" non selezionabile
  const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  text.setAttribute('x', frameX + frameW / 2);
  text.setAttribute('y', frameY - wallThickness / 2 + 2);
  text.setAttribute('text-anchor', 'middle');
  text.setAttribute('fill', '#333');
  text.setAttribute('font-size', '11');
  text.setAttribute('font-weight', 'bold');
  text.setAttribute('pointer-events', 'none');
  text.setAttribute('user-select', 'none');
  text.textContent = 'PARETE';
  svg.appendChild(text);
}

// Aggiorna il metodo drawColumns
drawColumns(svg, frameX, frameY, frameW, frameH, columnSize = 16) {

}

// Aggiorna drawSideClosures per ridurre dimensioni su mobile
drawSideClosures(svg, frameX, frameY, frameW, frameH, isMobile = false) {
  const closureStyles = {
    tende_zip: { 
      color: '#4CAF50', 
      pattern: 'dashed',
      width: isMobile ? 6 : 10, // Ridotto su mobile
      opacity: 0.7
    },
    vetrate: { 
      color: '#2196F3', 
      pattern: 'solid',
      width: isMobile ? 5 : 8, // Ridotto su mobile
      opacity: 0.6
    },
    frangisole: { 
      color: '#FF9800', 
      pattern: 'dotted',
      width: isMobile ? 8 : 12, // Ridotto su mobile
      opacity: 0.8
    },
    nessuna: { 
      color: 'transparent', 
      pattern: 'none',
      width: 0,
      opacity: 0
    }
  };

  const pergolaType = this.getPergolaType();
  const isAddossata = pergolaType.mount === 'addossata';

  const sides = [
    { 
      side: 'lato1', 
      points: { x1: frameX, y1: frameY, x2: frameX + frameW, y2: frameY },
      textPos: { x: frameX + frameW/2, y: frameY - (isMobile ? 15 : 25) }, // Ridotto su mobile
      wallSide: true
    },
    { 
      side: 'lato2', 
      points: { x1: frameX + frameW, y1: frameY, x2: frameX + frameW, y2: frameY + frameH },
      textPos: { x: frameX + frameW + (isMobile ? 20 : 30), y: frameY + frameH/2 } // Ridotto su mobile
    },
    { 
      side: 'lato3', 
      points: { x1: frameX + frameW, y1: frameY + frameH, x2: frameX, y2: frameY + frameH },
      textPos: { x: frameX + frameW/2, y: frameY + frameH + (isMobile ? 20 : 30) } // Ridotto su mobile
    },
    { 
      side: 'lato4', 
      points: { x1: frameX, y1: frameY + frameH, x2: frameX, y2: frameY },
      textPos: { x: frameX - (isMobile ? 20 : 30), y: frameY + frameH/2 } // Ridotto su mobile
    }
  ];

  sides.forEach(sideConfig => {
    const activeButton = this.productElement.querySelector(`.closure-btn[data-side="${sideConfig.side}"].active`);
    const closureType = activeButton ? activeButton.dataset.value : 'nessuna';
    const style = closureStyles[closureType];

    // Se è il lato 1 addossato, disegna il muro invece della chiusura
    if (sideConfig.side === 'lato1' && isAddossata) {
      this.drawWall(svg, frameX, frameY, frameW, frameH, isMobile);
      return;
    }

    if (closureType !== 'nessuna') {
      // Linea colorata per la chiusura
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', sideConfig.points.x1);
      line.setAttribute('y1', sideConfig.points.y1);
      line.setAttribute('x2', sideConfig.points.x2);
      line.setAttribute('y2', sideConfig.points.y2);
      line.setAttribute('stroke', style.color);
      line.setAttribute('stroke-width', style.width);
      line.setAttribute('stroke-linecap', 'round');
      line.setAttribute('opacity', style.opacity);
      line.setAttribute('pointer-events', 'none');
      
      // Applica pattern in base al tipo di chiusura
      if (style.pattern === 'dashed') {
        line.setAttribute('stroke-dasharray', isMobile ? '6,3' : '8,4'); // Ridotto su mobile
      } else if (style.pattern === 'dotted') {
        line.setAttribute('stroke-dasharray', isMobile ? '2,4' : '2,6'); // Ridotto su mobile
      }
      
      svg.appendChild(line);
    }

    // Etichetta del lato (sempre visibile tranne per lato 1 addossato)
    if (!(sideConfig.side === 'lato1' && isAddossata)) {
      const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      label.setAttribute('x', sideConfig.textPos.x);
      label.setAttribute('y', sideConfig.textPos.y);
      label.setAttribute('text-anchor', 'middle');
      label.setAttribute('fill', '#333');
      label.setAttribute('font-size', isMobile ? '10' : '12'); // Ridotto su mobile
      label.setAttribute('font-weight', 'bold');
      label.setAttribute('pointer-events', 'none');
      
      // Ruota le etichette per i lati verticali
      if (sideConfig.side === 'lato2' || sideConfig.side === 'lato4') {
        label.setAttribute('transform', `rotate(-90, ${sideConfig.textPos.x}, ${sideConfig.textPos.y})`);
      }
      
      const sideNumber = sideConfig.side.replace('lato', '');
      label.textContent = `Lato ${sideNumber}`;
      svg.appendChild(label);
    }
  });
}

// --- METODO PRINCIPALE AGGIORNATO PER DISEGNARE LA PERGOLA ---
updatePergolaSVG() {
  const svgElement = this.productElement.querySelector(`#pergola-svg-${this.index}`);
  const dimensionsInfo = this.productElement.querySelector(`#pergola-dimensions-${this.index}`);

  if (!svgElement) {
    console.error('Elemento SVG non trovato');
    return;
  }

  // Pulisci SVG completamente
  while (svgElement.firstChild) {
    svgElement.removeChild(svgElement.firstChild);
  }

  // Ottieni dimensioni
  const { width, height, originalWidth, originalHeight, hasValidDimensions } = this.getPergolaDimensions();
  
  // Imposta dimensioni SVG DINAMICHE in base al dispositivo - RIDOTTE
  const isMobile = this.isMobile();
  const totalWidth = isMobile ? 250 : 500; // Ridotto da 300 a 250
  const totalHeight = isMobile ? 180 : 400; // Ridotto da 220 a 180
  
  svgElement.setAttribute('width', totalWidth);
  svgElement.setAttribute('height', totalHeight);
  svgElement.setAttribute('viewBox', `0 0 ${totalWidth} ${totalHeight}`);

  // Calcola dimensioni del frame PROPORZIONALI ALLE MISURE REALI
  let frameWidth, frameHeight;
  
  if (hasValidDimensions) {
    // Usa le dimensioni calcolate dalle misure reali
    frameWidth = width;
    frameHeight = height;
  } else {
    // Usa dimensioni ridotte per il placeholder
    frameWidth = isMobile ? 220 : 350; // Ridotto
    frameHeight = isMobile ? 160 : 250; // Ridotto
  }
  
  // Centra il frame nel SVG
  const frameX = (totalWidth - frameWidth) / 2;
  const frameY = (totalHeight - frameHeight) / 2;
  
  // Aggiorna info dimensioni
  if (dimensionsInfo) {
    if (hasValidDimensions) {
      dimensionsInfo.innerHTML = `Pergola: ${originalWidth}cm × ${originalHeight}cm`;
    } else {
      dimensionsInfo.innerHTML = 'Inserisci le misure nella tab "Misure"';
      dimensionsInfo.style.color = '#ff6b6b';
    }
  }

  // Sfondo dell'area della pergola
  const background = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  background.setAttribute('x', frameX);
  background.setAttribute('y', frameY);
  background.setAttribute('width', frameWidth);
  background.setAttribute('height', frameHeight);
  background.setAttribute('fill', hasValidDimensions ? '#f0f0f0' : '#fff5f5');
  background.setAttribute('stroke', hasValidDimensions ? '#d0d0d0' : '#ffcccc');
  background.setAttribute('stroke-width', '1');
  svgElement.appendChild(background);

  // 1. Disegna cornice principale
  const frame = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  frame.setAttribute('x', frameX);
  frame.setAttribute('y', frameY);
  frame.setAttribute('width', frameWidth);
  frame.setAttribute('height', frameHeight);
  frame.setAttribute('fill', 'none');
  frame.setAttribute('stroke', hasValidDimensions ? '#333' : '#ff6b6b');
  frame.setAttribute('stroke-width', hasValidDimensions ? '2' : '1'); // Ridotto su mobile
  frame.setAttribute('stroke-dasharray', hasValidDimensions ? 'none' : '5,5');
  svgElement.appendChild(frame);

  // 2. Disegna pilastri angolari SOLO se misure valide
  if (hasValidDimensions) {
    // Riduci dimensione pilastri su mobile
    const columnSize = isMobile ? 12 : 16;
    
    //this.drawColumns(svgElement, frameX, frameY, frameWidth, frameHeight, columnSize);
    //this.drawAdditionalColumns(svgElement, frameX, frameY, frameWidth, frameHeight, columnSize);

    // 3. Determina il tipo di pergola e disegna la struttura appropriata
    const pergolaType = this.getPergolaType();
    
    console.log('Disegno pergola tipo:', pergolaType, 'Dimensioni:', frameWidth, 'x', frameHeight, 'Mobile:', isMobile);
    /*
    switch (pergolaType.main) {
      case 'bioclimatica':
        this.drawBioclimaticaLamelles(svgElement, frameX, frameY, frameWidth, frameHeight, isMobile);
        break;
      case 'pergotenda':
        this.drawPergotendaStructure(svgElement, frameX, frameY, frameWidth, frameHeight, isMobile);
        break;
      case 'pergola':
      case 'generic':
        this.drawGenericPergola(svgElement, frameX, frameY, frameWidth, frameHeight, isMobile);
        break;
    }*/

    // 4. Disegna chiusure laterali con dimensioni ridotte su mobile
    this.drawSideClosures(svgElement, frameX, frameY, frameWidth, frameHeight, isMobile);
  } else {
    // Messaggio per misure mancanti
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('x', totalWidth / 2);
    text.setAttribute('y', totalHeight / 2);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('fill', '#ff6b6b');
    text.setAttribute('font-size', isMobile ? '10' : '16'); // Ridotto su mobile
    text.setAttribute('font-weight', 'bold');
    text.textContent = 'Inserisci le misure';
    svgElement.appendChild(text);
  }

  console.log('SVG aggiornato per:', this.index, 'Frame:', frameWidth, 'x', frameHeight, 'Mobile:', isMobile);
}

// ---------------- NUOVO METODO: AGGIORNA STATO PULSANTI ----------------
updateSideButtonsState() {
  const pergolaType = this.getPergolaType();
  const isAddossata = pergolaType.mount === 'addossata';
  
  const lato1Buttons = this.productElement.querySelectorAll('.closure-btn[data-side="lato1"]');
  
  lato1Buttons.forEach(button => {
    if (isAddossata) {
      // Disabilita pulsanti lato 1 per strutture addossate
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.title = 'Il lato 1 non può avere chiusure quando la struttura è addossata al muro';
      
      // Se era selezionato, deseleziona e resetta a "nessuna"
      if (button.classList.contains('active') && button.dataset.value !== 'nessuna') {
        button.classList.remove('active');
        button.style.borderColor = '#e0e0e0';
        button.style.background = 'white';
        
        // Attiva il pulsante "nessuna" per il lato 1
        const nessunaButton = this.productElement.querySelector('.closure-btn[data-side="lato1"][data-value="nessuna"]');
        if (nessunaButton) {
          nessunaButton.classList.add('active');
          nessunaButton.style.borderColor = '#c68c4c';
          nessunaButton.style.background = '#fff8f0';
        }
      }
    } else {
      // Riabilita pulsanti per strutture non addossate
      button.disabled = false;
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
      button.title = '';
    }
  });
  
  this.saveClosureConfiguration();
}


getClosureLabel(closureType) {
  const labels = {
    tende_zip: 'TENDE',
    vetrate: 'VETRI',
    frangisole: 'FRANGI'
  };
  return labels[closureType] || '';
}

saveClosureConfiguration() {
  const configInput = this.productElement.querySelector('input[name*="[Configurazione_Chiusure]"]');
  const closureButtons = this.productElement.querySelectorAll('.closure-btn.active');
  
  const configuration = {};
  closureButtons.forEach(button => {
    configuration[button.dataset.side] = button.dataset.value;
  });
  
  if (configInput) {
    configInput.value = JSON.stringify(configuration);
    this.saveData();
  }
}

resetSideSelection() {
  const closureButtons = this.productElement.querySelectorAll('.closure-btn');
  closureButtons.forEach(button => {
    if (button.dataset.value === 'nessuna') {
      button.classList.add('active');
      button.style.borderColor = '#c68c4c';
      button.style.background = '#fff8f0';
    } else {
      button.classList.remove('active');
      button.style.borderColor = '#e0e0e0';
      button.style.background = 'white';
    }
  });
  
  // AGGIUNTO: Salva la configurazione "nessuna" per tutti i lati
  const configInput = this.productElement.querySelector('input[name*="[Configurazione_Chiusure]"]');
  if (configInput) {
    const configuration = {
      lato1: 'nessuna',
      lato2: 'nessuna', 
      lato3: 'nessuna',
      lato4: 'nessuna'
    };
    configInput.value = JSON.stringify(configuration);
  }
  
  this.updatePergolaSVG();
  this.saveData(); // AGGIUNTO: Salva i dati
}

loadClosureData(productData) {
  const closureTab = this.productElement.querySelector('[data-tab^="side-closures-"]');
  if (!closureTab) return;

  console.log('Caricamento dati chiusure per:', this.uniqueProductId);
  console.log('Tutti i dati salvati:', productData.inputs);

  // CERCA DIRETTAMENTE I CAMPI SENZA NORMALIZZAZIONE
  let configValue = null;
  let chiusureValue = null;

  // Cerca nei nomi originali
  Object.keys(productData.inputs).forEach(key => {
    if (key.includes('Configurazione_Chiusure')) {
      configValue = productData.inputs[key];
      console.log('Trovato Configurazione_Chiusure:', configValue);
    }
    if (key.includes('Chiusure_Laterali')) {
      chiusureValue = productData.inputs[key];
      console.log('Trovato Chiusure_Laterali:', chiusureValue);
    }
  });

  // PRIMA: Configurazione chiusure
  if (configValue) {
    try {
      const configuration = JSON.parse(configValue);
      console.log('Configurazione chiusure caricata:', configuration);
      
      // Trova l'input hidden per la configurazione
      const configInput = this.productElement.querySelector('input[name*="Configurazione_Chiusure"]');
      if (configInput) {
        configInput.value = configValue;
        console.log('Input config impostato a:', configValue);
      }
      
      // Reset di tutti i pulsanti
      const closureButtons = this.productElement.querySelectorAll('.closure-btn');
      closureButtons.forEach(button => {
        button.classList.remove('active');
        button.style.borderColor = '#e0e0e0';
        button.style.background = 'white';
      });
      
      // Imposta i pulsanti attivi
      Object.keys(configuration).forEach(side => {
        const value = configuration[side];
        const activeButton = this.productElement.querySelector(`.closure-btn[data-side="${side}"][data-value="${value}"]`);
        if (activeButton) {
          console.log('Impostando pulsante attivo:', side, value);
          activeButton.classList.add('active');
          activeButton.style.borderColor = '#c68c4c';
          activeButton.style.background = '#fff8f0';
        }
      });
      
    } catch (error) {
      console.error('Errore nel caricamento configurazione chiusure:', error);
    }
  }

  // POI: Toggle principale
  if (chiusureValue) {
    const hiddenInput = this.productElement.querySelector('input[name*="Chiusure_Laterali"]');
    const toggleOptions = this.productElement.querySelectorAll('.toggle-option');
    const configurationSection = this.productElement.querySelector('.closure-configuration');
    
    if (hiddenInput) {
      hiddenInput.value = chiusureValue;
      console.log('Input Chiusure_Laterali impostato a:', chiusureValue);
    }
    
    // Attiva il pulsante toggle corretto
    toggleOptions.forEach(option => {
      const button = option.querySelector('.toggle-btn');
      if (option.dataset.value === chiusureValue) {
        console.log('Attivando pulsante toggle:', chiusureValue);
        
        // Rimuovi active da tutti
        toggleOptions.forEach(opt => {
          const btn = opt.querySelector('.toggle-btn');
          btn.classList.remove('active');
          btn.style.borderColor = '#e0e0e0';
          btn.style.background = 'white';
        });

        // Imposta active sul corretto
        button.classList.add('active');
        button.style.borderColor = '#c68c4c';
        button.style.background = '#fff8f0';

        // Mostra/nascondi configurazione
        if (chiusureValue === 'si') {
          configurationSection.style.display = 'block';
        } else {
          configurationSection.style.display = 'none';
        }
      }
    });
  }

  // Aggiorna stato finale
  setTimeout(() => {
    this.updateSideButtonsState();
    this.updatePergolaSVG();
  }, 300);
}


  // ---------------- MEMORIA DATI (MODIFICATO) ----------------
  saveData() {
    const productData = {
      currentTab: this.currentTab,
      inputs: {},
      completed: this.productElement.classList.contains('completed'),
      productId: this.getUniqueProductId(),
      uniqueProductId: this.uniqueProductId,
      timestamp: new Date().getTime(), // Aggiungi timestamp per ordinamento
      selectedColors: this.selectedColors || {},
      hasMultipleColorTypes: !!this.productElement.querySelector('.fabric-category-section')
    };

    // Salva tutti i valori degli input con NOME NORMALIZZATO
    this.productElement.querySelectorAll('input, select, textarea').forEach(input => {
      if (input.type === 'file') return;
      
      const key = this.normalizeFieldName(input.name || input.id);
      if (key) {
        if (input.type === 'checkbox') {
          productData.inputs[key] = input.checked;
        } else {
          productData.inputs[key] = input.value;
        }

              // DEBUG: Log per le chiusure
      if (key.includes('Configurazione_Chiusure')) {
        console.log('SALVATAGGIO Configurazione_Chiusure:', input.value);
      }
      if (key.includes('Chiusure_Laterali')) {
        console.log('SALVATAGGIO Chiusure_Laterali:', input.value);
      }

      }
    });


    // Salva informazioni sulle misure multiple
    const measureGroups = this.productElement.querySelectorAll('.measure-group');
    productData.measureCount = measureGroups.length;

    // Salva i valori specifici delle misure multiple
    productData.measurements = {};
    measureGroups.forEach((group, index) => {
      const measureIndex = index + 1;
      const widthInput = group.querySelector(`#width-${this.index}-${measureIndex}`);
      const protrusionInput = group.querySelector(`#protrusion-${this.index}-${measureIndex}`);
      
      if (widthInput) {
        productData.measurements[`width_${measureIndex}`] = widthInput.value;
      }
      if (protrusionInput) {
        productData.measurements[`protrusion_${measureIndex}`] = protrusionInput.value;
      }
    });

    // Salva stato colori
    const selectedColor = this.productElement.querySelector('.color-item-collapsible-row-2.selected');
    if (selectedColor) {
      productData.selectedColor = selectedColor.querySelector('.color-name-collapsible-row-2').textContent;
    }

    // Salva stato "colore dopo"
    const laterColorSelected = this.productElement.classList.contains('color-later-selected');
    productData.laterColorSelected = laterColorSelected;

    // Salva stato tessuti
    const selectedFabric = this.productElement.querySelector('.color-item-collapsible-row-2[data-tessuto-name].selected');
    if (selectedFabric) {
      productData.selectedFabric = selectedFabric.dataset.tessutoName;
    }

    // Salva stato "tessuto dopo"
    const laterFabricSelected = this.productElement.querySelector('.color-later-toggle[data-type="tessuto"]')?.closest('.color-later-option').classList.contains('color-later-selected');
    productData.laterFabricSelected = laterFabricSelected;

    // Salva optional metafield
    const optionalMetafieldInput = this.productElement.querySelector(`#optional-metafield-${this.index}`);
    if (optionalMetafieldInput) {
      productData.optionalMetafieldValues = optionalMetafieldInput.value;
    }

    // Salva optional fissi
    const optionalFixedInput = this.productElement.querySelector(`#optional-fixed-${this.index}`);
    if (optionalFixedInput) {
      productData.optionalFixedValues = optionalFixedInput.value;
    }

    // Salva valori LED
    const ledInput = this.productElement.querySelector(`#led-values-${this.index}`);
    if (ledInput) {
      productData.ledValues = ledInput.value;
    }

    // USA L'ID UNIVOCO invece del semplice index
    localStorage.setItem(`estimator_${this.uniqueProductId}`, JSON.stringify(productData));
    console.log('Dati salvati per:', this.uniqueProductId, 'Misure:', productData.measureCount);

   
  }

// ---------------- CARICAMENTO DATI MIGLIORATO ----------------
loadSavedData() {
  // PRIMA cerca i dati per questa specifica unità
  let saved = localStorage.getItem(`estimator_${this.uniqueProductId}`);
  
  if (saved) {
    console.log('Trovati dati specifici per unità:', this.uniqueProductId);
    try {
      const productData = JSON.parse(saved);
      this.loadDataFromObject(productData);
      return;
    } catch (error) {
      console.error('Errore nel caricamento dati salvati:', error);
      this.clearSavedData();
      return;
    }
  }
  
  console.log('Nessun dato salvato trovato per unità specifica:', this.uniqueProductId);
  
  // SE NON CI SONO DATI PER QUESTA UNITÀ SPECIFICA, LA LASCIAMO VUOTA
  console.log('Unità lasciata vuota - nessun dato specifico trovato');
  
  // NON cercare dati da altre unità - ogni unità deve avere i propri dati
  return;
}

// ---------------- CERCA DATI DISPONIBILI PER PRODUCT_VARIANT ----------------
findAvailableDataForProductVariant(productId, variantId) {
  const productVariantBase = `product_${productId}_variant_${variantId}`;
  const availableData = [];
  
  // Cerca tutte le unità salvate per questo product_variant
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    
    if (key && key.startsWith(`estimator_${productVariantBase}_unita`)) {
      try {
        const data = JSON.parse(localStorage.getItem(key));
        if (data && data.timestamp) {
          // VERIFICA SE I DATI SONO PER LA STESSA UNITÀ
          const unitMatch = key.match(/unita(\d+)$/);
          if (unitMatch) {
            const dataUnitIndex = parseInt(unitMatch[1]);
            const currentUnitIndex = this.getUnitIndexForProductVariant(productId, variantId);
            
            // SOLO se i dati sono per la stessa unità, li consideriamo
            if (dataUnitIndex === currentUnitIndex) {
              availableData.push({ key, data, timestamp: data.timestamp });
            }
          }
        }
      } catch (e) {
        console.warn('Dati corrotti per:', key);
      }
    }
  }
  
  // Ordina per timestamp (più recenti prima) e restituisci il primo disponibile
  if (availableData.length > 0) {
    availableData.sort((a, b) => b.timestamp - a.timestamp);
    console.log('Dati disponibili per unità specifica:', availableData);
    return availableData[0].data;
  }
  
  return null;
}

  // ---------------- CARICA DATI DA OGGETTO ----------------
// ---------------- CARICA DATI DA OGGETTO ----------------
loadDataFromObject(productData) {
  console.log('Caricamento dati da:', productData.uniqueProductId, productData);
  
  // VERIFICA CHE I DATI SALVATI SIANO COMPATIBILI
  if (productData.uniqueProductId && productData.uniqueProductId !== this.uniqueProductId) {
    console.log('Caricamento dati da unità diversa:', productData.uniqueProductId, '→', this.uniqueProductId);
  }
  
  // RIPRISTINA LE MISURE MULTIPLE PRIMA DI TUTTO
  if (productData.measureCount && productData.measureCount > 1) {
    this.recreateMultipleMeasures(productData.measureCount, productData.measurements);
  }

  // PRIMA CARICA LE CHIUSURE - IMPORTANTE!
  this.loadClosureData(productData);

  // AGGIUNTO: Carica dati consegna e montaggio
  this.loadDeliveryMontaggioData(productData);

  // POI ripristina gli altri valori
  Object.keys(productData.inputs).forEach(normalizedKey => {
    const input = this.findInputByNormalizedName(normalizedKey);
    if (input) {
      if (input.type === 'checkbox') {
        input.checked = productData.inputs[normalizedKey];
      } else {
        input.value = productData.inputs[normalizedKey];
      }
    }
  });

  // ATTIVA I CAMPI CONDIZIONALI PRIMA di ripristinare i valori
  this.activateConditionalFields();

  // CORREZIONE: Ripristina PRIMA i colori multipli dal valore salvato
  const verniciaturaKey = Object.keys(productData.inputs).find(key => key.includes('Verniciatura'));
  if (verniciaturaKey && productData.inputs[verniciaturaKey]) {
    const verniciaturaValue = productData.inputs[verniciaturaKey];
    console.log('Trovato valore verniciatura salvato:', verniciaturaValue);
    
    // Imposta direttamente l'input hidden
    const verniciaturaInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
    if (verniciaturaInput) {
      verniciaturaInput.value = verniciaturaValue;
    }
    
    // Se sono colori multipli, ripristina le selezioni visive
    /*if (verniciaturaValue.includes('|')) {
      setTimeout(() => {
        this.restoreMultipleColorSelections();
      }, 100);
    }*/


  }
  // Altrimenti mantieni il comportamento originale per colori singoli
  else if (productData.selectedColor && !productData.laterColorSelected) {
    const colorItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2:not([data-colore-name])');
    colorItems.forEach(item => {
      if (item.querySelector('.color-name-collapsible-row-2').textContent === productData.selectedColor) {
        item.classList.add('selected');
        const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
        const colorName = item.querySelector('.color-name-collapsible-row-2').textContent;
        const colorCode = item.querySelector('.color-code-collapsible-row-2').textContent;
        if (hiddenInput) {
          hiddenInput.value = `${colorName} (${colorCode})`;
        }
      }
    });
  }

  // Ripristina selezioni colori multiple
  if (productData.selectedColors && productData.hasMultipleColorTypes) {
    this.selectedColors = productData.selectedColors;
    this.restoreColorSelections();
  }

  // Ripristina stato "colore dopo"
  if (productData.laterColorSelected) {
    this.setLaterColorSelection();
  }

  // Ripristina tessuto selezionato
  if (productData.selectedFabric && !productData.laterFabricSelected) {
    const fabricItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2[data-tessuto-name]');
    fabricItems.forEach(item => {
      if (item.dataset.tessutoName === productData.selectedFabric) {
        item.classList.add('selected');
        const hiddenInput = this.productElement.querySelector(`#tessuto-${this.index}`);
        if (hiddenInput) {
          hiddenInput.value = `${item.dataset.tessutoName} (${item.dataset.tessutoCode})`;
        }
      }
    });
  }

  // Ripristina stato "tessuto dopo"
  if (productData.laterFabricSelected) {
    this.setLaterFabricSelection();
  }

  // Ripristina optional metafield
  if (productData.optionalMetafieldValues) {
    const optionalInput = this.productElement.querySelector(`#optional-metafield-${this.index}`);
    if (optionalInput) {
      optionalInput.value = productData.optionalMetafieldValues;
      this.restoreMultiSelectionState('.optional-card[data-type="metafield"]', productData.optionalMetafieldValues);
    }
  }

  // Ripristina optional fissi
  if (productData.optionalFixedValues) {
    const optionalInput = this.productElement.querySelector(`#optional-fixed-${this.index}`);
    if (optionalInput) {
      optionalInput.value = productData.optionalFixedValues;
      this.restoreMultiSelectionState('.optional-card[data-type="fixed"]', productData.optionalFixedValues);
    }
  }

  // Ripristina LED
  if (productData.ledValues) {
    const ledInput = this.productElement.querySelector(`#led-values-${this.index}`);
    if (ledInput) {
      ledInput.value = productData.ledValues;
      this.restoreMultiSelectionState('.optional-card[data-type="led"]', productData.ledValues);
    }
  }

  // Ripristina tab corrente
  if (productData.currentTab) {
    this.currentTab = productData.currentTab;
  }

  // SE IL PRODOTTO ERA COMPLETATO, MOSTRA SUBITO IL RIEPILOGO
  if (productData.completed) {
    this.showRecapDirectly();
  }
}

  // ---------------- NORMALIZZAZIONE NOMI CAMPI ----------------
  normalizeFieldName(fieldName) {
    if (!fieldName) return null;
    
    // Rimuove l'indice specifico dal nome del campo
    return fieldName.replace(/\[\d+-\d+\]/, '[]');
  }

  findInputByNormalizedName(normalizedName) {
    const inputs = this.productElement.querySelectorAll('input, select, textarea');
    
    for (let input of inputs) {
      if (input.type === 'file') continue;
      
      const currentNormalizedName = this.normalizeFieldName(input.name || input.id);
      if (currentNormalizedName === normalizedName) {
        return input;
      }
    }
    
    return null;
  }

  // ---------------- METODO PER RICOSTRUIRE MISURE MULTIPLE ----------------
  recreateMultipleMeasures(measureCount, measurements = {}) {
    const measuresContainer = this.productElement.querySelector('.measures-container');
    if (!measuresContainer || measureCount <= 1) return;

    console.log('Ricostruzione misure multiple:', measureCount, measurements);

    // Rimuovi tutte le misure tranne la prima
    const existingMeasures = measuresContainer.querySelectorAll('.measure-group');
    for (let i = 1; i < existingMeasures.length; i++) {
      if (existingMeasures[i]) {
        existingMeasures[i].remove();
      }
    }

    // Ricrea le misure aggiuntive
    for (let i = 2; i <= measureCount; i++) {
      const newMeasureGroup = this.createMeasureGroup(i);
      measuresContainer.appendChild(newMeasureGroup);
    }

    // Ripristina i valori delle misure
    this.restoreMeasureValues(measurements);

    // Aggiorna il pulsante
    this.updateAddMeasureButton(measureCount);
  }

  // ---------------- RIPRISTINA VALORI MISURE ----------------
  restoreMeasureValues(measurements) {
    console.log('Ripristino valori misure:', measurements);
    
    Object.keys(measurements).forEach(key => {
      const match = key.match(/(width|protrusion)_(\d+)/);
      if (match) {
        const type = match[1];
        const measureIndex = match[2];
        const value = measurements[key];
        
        const input = this.productElement.querySelector(`#${type}-${this.index}-${measureIndex}`);
        if (input && value) {
          input.value = value;
          console.log(`Ripristinato ${type} misura ${measureIndex}:`, value);
        }
      }
    });
  }

  // ---------------- CREA GRUPPO MISURA ----------------
  createMeasureGroup(measureIndex) {
    // Controlla se esiste già un campo "Altezza" nello stesso blocco
    const existingLabels = this.productElement.querySelectorAll('label');
    let hasAltezzaField = false;
    
    existingLabels.forEach(label => {
        if (label.textContent.includes('Altezza (cm)')) {
            hasAltezzaField = true;
        }
    });
    
    const measureGroup = document.createElement('div');
    measureGroup.className = 'measure-group';
    measureGroup.dataset.measureIndex = measureIndex;

    measureGroup.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <h4 style="margin: 0; color: #333; font-size: 1.4rem;">Misura ${measureIndex}</h4>
        ${measureIndex > 1 ? `
          <button type="button" class="remove-measure" data-product-index="${this.index}" data-measure-index="${measureIndex}"
                  style="background: #dc3545; color: white; border: none; padding: 0.5rem 1rem; 
                        cursor: pointer; font-size: 1.2rem; border-radius: 4px;">
            Rimuovi
          </button>
        ` : ''}
      </div>
      <label>Larghezza (cm)</label>
      <input type="number" id="width-${this.index}-${measureIndex}" 
             name="properties[${this.index}][Larghezza_${measureIndex}]" 
             placeholder="Inserisci la larghezza" required
             style="width: 100%; padding: 1rem; border: 1px solid #ddd; margin-bottom: 1rem;">
      
      <label>${hasAltezzaField ? 'Altezza (cm)' : 'Sporgenza (cm)'}</label>
      <input type="number" id="protrusion-${this.index}-${measureIndex}" 
             name="properties[${this.index}][${hasAltezzaField ? 'Altezza' : 'Sporgenza'}_${measureIndex}]" 
             placeholder="Inserisci ${hasAltezzaField ? 'l\'altezza' : 'la sporgenza'}" required
             style="width: 100%; padding: 1rem; border: 1px solid #ddd; margin-bottom: 1rem;">
    `;

    // Aggiungi event listener per il pulsante rimuovi
    const removeBtn = measureGroup.querySelector('.remove-measure');
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        const measureIndexToRemove = parseInt(removeBtn.dataset.measureIndex);
        this.removeMeasure(measureIndexToRemove);
      });
    }

    // Aggiungi event listener per salvare quando i valori cambiano
    const inputs = measureGroup.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('change', () => this.saveData());
      input.addEventListener('input', () => this.saveData());
    });

    return measureGroup;
  }


  // ---------------- AGGIUNGI MISURA ----------------
  addAnotherMeasure() {
    const measuresContainer = this.productElement.querySelector('.measures-container');
    if (!measuresContainer) return;

    // Conta quante misure ci sono già
    const existingMeasures = measuresContainer.querySelectorAll('.measure-group');
    const nextMeasureIndex = existingMeasures.length + 1;

    if (nextMeasureIndex > 2) {
      alert('Puoi aggiungere massimo 2 misure per prodotto');
      return;
    }

    // Crea il nuovo gruppo di misure
    const newMeasureGroup = this.createMeasureGroup(nextMeasureIndex);
    measuresContainer.appendChild(newMeasureGroup);

    // Aggiorna il testo del pulsante
    this.updateAddMeasureButton(nextMeasureIndex);

    // Salva i dati
    this.saveData();

    console.log(`Aggiunta misura ${nextMeasureIndex} per prodotto ${this.index}`);
  }

  // ---------------- RIMUOVI MISURA ----------------
  removeMeasure(measureIndex) {
    const measureToRemove = this.productElement.querySelector(`.measure-group[data-measure-index="${measureIndex}"]`);
    if (measureToRemove) {
      measureToRemove.remove();
      
      // Rinumera le misure rimanenti
      this.renumberMeasures();
      
      // Aggiorna il pulsante aggiungi misura
      this.updateAddMeasureButton();
      
      // Salva i dati
      this.saveData();
      
      console.log(`Rimossa misura ${measureIndex} dal prodotto ${this.index}`);
    }
  }

  // ---------------- RINUMERA MISURE ----------------
  renumberMeasures() {
    const measuresContainer = this.productElement.querySelector('.measures-container');
    if (!measuresContainer) return;

    const measureGroups = measuresContainer.querySelectorAll('.measure-group');
    
    measureGroups.forEach((group, index) => {
      const newIndex = index + 1;
      group.dataset.measureIndex = newIndex;
      
      // Aggiorna il titolo
      const title = group.querySelector('h4');
      if (title) title.textContent = `Misura ${newIndex}`;
      
      // Aggiorna gli input
      const widthInput = group.querySelector(`#width-${this.index}-${newIndex}`);
      const protrusionInput = group.querySelector(`#protrusion-${this.index}-${newIndex}`);
      
      if (widthInput) {
        widthInput.name = `properties[${this.index}][Larghezza_${newIndex}]`;
        widthInput.id = `width-${this.index}-${newIndex}`;
      }
      
      if (protrusionInput) {
        protrusionInput.name = `properties[${this.index}][Sporgenza_${newIndex}]`;
        protrusionInput.id = `protrusion-${this.index}-${newIndex}`;
      }
      
      // Mostra/nascondi pulsante rimuovi
      const removeBtn = group.querySelector('.remove-measure');
      if (removeBtn) {
        removeBtn.dataset.measureIndex = newIndex;
        if (newIndex === 1) {
          removeBtn.style.display = 'none';
        } else {
          removeBtn.style.display = 'block';
        }
      }
    });
  }

  // ---------------- AGGIORNA PULSANTE AGGIUNGI MISURA ----------------
  updateAddMeasureButton(currentMeasureCount = null) {
    const addButton = this.productElement.querySelector('.add-another-measure');
    if (!addButton) return;

    const measuresCount = currentMeasureCount || this.productElement.querySelectorAll('.measure-group').length;
    
    if (measuresCount >= 2) {
      addButton.disabled = true;
      addButton.style.display = 'none';
      addButton.style.background = '#6c757d';
      addButton.innerHTML = 'Massimo 2 misure raggiunto';
      addButton.title = 'Realizzeremo il preventivo per entrambe le misure richieste :)';
    } else {
      addButton.disabled = false;
      addButton.style.display = 'block';
      addButton.style.background = '#c68c4c';
      addButton.innerHTML = '<span>+</span> Aggiungi un\'altra misura per confronto';
      addButton.title = '';
    }
  }

  // MOSTRA DIRETTAMENTE IL RIEPILOGO SENZA PASSARE DAL FORM
  showRecapDirectly() {
    this.productElement.querySelector('.estimator__form-content').style.display = 'none';
    this.fillRecap();
    if (this.recapBox) {
      this.recapBox.style.display = 'block';
    }
    this.productElement.classList.add('completed');
    checkSubmitEnable();
  }

  // ATTIVA I CAMPI CONDIZIONALI BASATI SUI VALORI CORRENTI
  activateConditionalFields() {
    // Gestione cappotto
    const cappottoSelect = this.productElement.querySelector(`#cappotto-select-${this.index}`);
    if (cappottoSelect) {
      this.handleCappottoChange(cappottoSelect.value === 'si');
    }

    // Gestione struttura e attacco
    const structure = document.getElementById(`structure-type-${this.index}`);
    if (structure && structure.value) {
      this.handleStructureChange(structure.value);
    }

    // Gestione attacco specifico
    const attachment = document.getElementById(`attachment-type-${this.index}`);
    if (attachment && attachment.value) {
      this.handleAttachmentChange(attachment.value);
    }
  }

  clearSavedData() {
    localStorage.removeItem(`estimator_${this.uniqueProductId}`);
    localStorage.removeItem(`estimator_files_${this.uniqueProductId}`);
    console.log('Dati puliti per:', this.uniqueProductId);
  }

  // ---------------- CONVERSIONE HEIC E COMPRESSIONE ----------------
async processImageFile(file) {
  console.log(`Processamento file: ${file.name}, Tipo: ${file.type}, Dimensione: ${(file.size / 1024 / 1024).toFixed(2)}MB`);

  let processedFile = file;

  // STEP 1: Converti HEIC in JPEG se necessario
  if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
    console.log('Conversione HEIC in JPEG...');
    try {
      processedFile = await this.convertHEICtoJPEG(file);
      console.log('HEIC convertito con successo');
    } catch (error) {
      console.error('Errore conversione HEIC:', error);
      throw new Error('Impossibile convertire il file HEIC. Usa un formato diverso.');
    }
  }

  // STEP 2: Comprimi se > 1MB
  if (processedFile.size > 1024 * 1024) { // 1MB
    console.log('Compressione immagine...');
    try {
      processedFile = await this.compressImage(processedFile);
      console.log(`Compresso da ${(file.size / 1024 / 1024).toFixed(2)}MB a ${(processedFile.size / 1024 / 1024).toFixed(2)}MB`);
    } catch (error) {
      console.error('Errore compressione:', error);
      // Continua con il file non compresso
    }
  }

  return processedFile;
}

// ---------------- CONVERSIONE HEIC A JPEG ----------------
async convertHEICtoJPEG(heicFile) {
  return new Promise((resolve, reject) => {
    try {
      // Usa la libreria heic2any
      heic2any({
        blob: heicFile,
        toType: 'image/jpeg',
        quality: 0.8
      })
      .then((jpegBlob) => {
        // Crea un nuovo File object con nome .jpg
        const jpegFile = new File(
          [jpegBlob], 
          heicFile.name.replace(/\.heic$/i, '.jpg').replace(/\.HEIC$/i, '.jpg'),
          { type: 'image/jpeg' }
        );
        resolve(jpegFile);
      })
      .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

// ---------------- COMPRESSIONE IMMAGINE MIGLIORATA ----------------
async compressImage(file, maxWidth = 1600, maxFileSize = 1024 * 1024) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      let { width, height } = img;
      const originalWidth = width;
      const originalHeight = height;

      console.log(`Compressione: ${file.name}, Originale: ${width}x${height}, ${(file.size / 1024 / 1024).toFixed(2)}MB`);

      // Calcola nuove dimensioni mantenendo aspect ratio
      if (width > maxWidth || height > maxWidth) {
        const ratio = width / height;
        if (width > height) {
          width = maxWidth;
          height = Math.round(maxWidth / ratio);
        } else {
          height = maxWidth;
          width = Math.round(maxWidth * ratio);
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Imposta qualità iniziale basata sulla dimensione originale
      let initialQuality = 0.8;
      if (file.size > 5 * 1024 * 1024) {
        initialQuality = 0.6;
      } else if (file.size > 10 * 1024 * 1024) {
        initialQuality = 0.5;
      }

      // Disegna l'immagine con alta qualità
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, width, height);

      // Funzione ricorsiva per trovare la qualità ottimale
      const optimizeQuality = (quality, attempt = 0) => {
        canvas.toBlob((blob) => {
          const sizeMB = blob.size / 1024 / 1024;
          
          console.log(`Tentativo ${attempt + 1}: Qualità ${quality.toFixed(2)} -> ${sizeMB.toFixed(2)}MB`);

          if (blob.size <= maxFileSize || quality <= 0.3 || attempt >= 5) {
            const finalFile = new File([blob], file.name, { type: 'image/jpeg' });
            console.log(`Compressione completata: ${sizeMB.toFixed(2)}MB, Qualità finale: ${quality.toFixed(2)}`);
            resolve(finalFile);
          } else {
            const newQuality = quality * 0.8;
            optimizeQuality(newQuality, attempt + 1);
          }
        }, 'image/jpeg', quality);
      };

      optimizeQuality(initialQuality);
    };

    img.onerror = () => {
      reject(new Error('Errore nel caricamento immagine per compressione'));
    };

    img.src = URL.createObjectURL(file);
  });
}

// ---------------- CREAZIONE PREVIEW ----------------
async createFilePreview(processedFile, originalName, previewContainer) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const previewItem = document.createElement('div');
      previewItem.className = 'image-preview-item';
      
      const fileSizeInfo = ` (${(processedFile.size / 1024 / 1024).toFixed(2)}MB)`;
      const displayName = processedFile.name !== originalName ? 
        `${originalName} → ${processedFile.name}${fileSizeInfo}` : 
        `${originalName}${fileSizeInfo}`;
      
      previewItem.innerHTML = `
        <img src="${e.target.result}" alt="${originalName}" class="image-preview-img">
        <button type="button" class="image-preview-remove" data-filename="${originalName}">×</button>
        <div class="image-preview-name">${displayName}</div>
      `;
      
      previewContainer.appendChild(previewItem);

      previewItem.querySelector('.image-preview-remove').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.removeFileByName(originalName);
      });

      resolve();
    };
    
    reader.onerror = () => {
      reject(new Error(`Errore lettura file: ${originalName}`));
    };
    
    reader.readAsDataURL(processedFile);
  });
}

// ---------------- INDICATORE PROGRESSO UPLOAD ----------------
showUploadProgress(totalFiles) {
  let progressContainer = this.productElement.querySelector('.upload-progress-container');
  
  if (!progressContainer) {
    progressContainer = document.createElement('div');
    progressContainer.className = 'upload-progress-container';
    progressContainer.style.cssText = `
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 15px;
      margin: 10px 0;
      display: none;
    `;
    
    progressContainer.innerHTML = `
      <div class="upload-progress-text" style="margin-bottom: 8px; font-size: 14px; color: #495057;"></div>
      <div class="upload-progress-bar" style="width: 100%; height: 6px; background: #e9ecef; border-radius: 3px; overflow: hidden;">
        <div class="upload-progress-fill" style="width: 0%; height: 100%; background: #28a745; transition: width 0.3s ease;"></div>
      </div>
    `;
    
    const fileUploadArea = this.productElement.querySelector('.file-upload-area');
    if (fileUploadArea) {
      fileUploadArea.parentNode.insertBefore(progressContainer, fileUploadArea.nextSibling);
    }
  }
  
  progressContainer.style.display = 'block';
}

updateUploadProgress(current, total, message = '') {
  const progressContainer = this.productElement.querySelector('.upload-progress-container');
  if (!progressContainer) return;
  
  const progressText = progressContainer.querySelector('.upload-progress-text');
  const progressFill = progressContainer.querySelector('.upload-progress-fill');
  
  const percent = (current / total) * 100;
  
  if (progressText) {
    progressText.textContent = message || `Processamento ${current} di ${total} files... (${Math.round(percent)}%)`;
  }
  
  if (progressFill) {
    progressFill.style.width = `${percent}%`;
  }
}

hideUploadProgress() {
  const progressContainer = this.productElement.querySelector('.upload-progress-container');
  if (progressContainer) {
    progressContainer.style.display = 'none';
  }
}


// ---------------- GESTIONE ARREDO ESTERNO ----------------
setupArredoEsterno() {
  const tagsInput = this.productElement.querySelector('input[name*="[Tags_Prodotto]"]');
  const tags = (tagsInput ? tagsInput.value.toLowerCase() : '').trim();
  
  const isArredoEsterno = tags.includes('arredo esterno') || tags.includes('arredoesterno');
  
  if (isArredoEsterno) {
    this.setupArredoTabs();
    this.hideUnnecessaryTabs();
  }
}

// MODIFICA setupArredoTabs per MARCHIARE le tab nascoste
setupArredoTabs() {
  console.log('🛋️ Configurando tab per arredo esterno');
  
  // Marchia e nascondi tab non necessarie per arredo
  const tabsToHide = ['measures','structure', 'attachment', 'existing-structure', 'side-closures', 'motorization', 'fabrics', 'led'];
  
  tabsToHide.forEach(tabType => {
    const tab = this.productElement.querySelector(`[data-tab*="${tabType}-"]`);
    if (tab) {
      tab.style.display = 'none';
      tab.setAttribute('data-hidden-for-arredo', 'true');
      console.log(`❌ Tab ${tabType} nascosta e marchiata per arredo`);
    }
  });
  
  this.addArredoTabs();
  
  // AGGIUNGI QUESTA RIGA:
  this.updateTabsList();
  this.productElement.querySelector('.next-tab').click();
  
  console.log('✅ Tab arredo configurate');
}

hideTab(tabType) {
  const tab = this.productElement.querySelector(`[data-tab*="${tabType}-"]`);
  if (tab) {
    tab.style.display = 'none';
  }
}

addArredoTabs() {
  // Aggiungi tab "Consegna" dopo la tab verniciatura
  this.addConsegnaTab();
  
  // Aggiungi tab "Montaggio" dopo la tab consegna
  this.addMontaggioTab();
}

addConsegnaTab() {
  const tabsContainer = this.productElement.querySelector('.estimator-tabs');
  const paintTab = this.productElement.querySelector('[data-tab*="paint-"]');
  
  if (!tabsContainer || !paintTab) return;
  
  const consegnaTab = document.createElement('div');
  consegnaTab.className = 'estimator-tab';
  consegnaTab.dataset.tab = `consegna-${this.index}`;
  consegnaTab.innerHTML = `
    <label>Modalità di Consegna</label>
    
    <div class="delivery-options" style="margin: 2rem 0;">
      <div class="delivery-option" style="margin-bottom: 1.5rem; padding: 1.5rem; border: 2px solid #e0e0e0; cursor: pointer;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div class="delivery-radio" style="width: 20px; height: 20px; border: 2px solid #ccc; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <div style="width: 10px; height: 10px; background: #c68c4c; border-radius: 50%; display: none;"></div>
          </div>
          <div>
            <div style="font-weight: 600; color: #333; margin-bottom: 0.5rem;">Ritiro in Sede</div>
            <div style="font-size: 1.2rem; color: #666;">
              Ritira il tuo arredo direttamente presso il nostro showroom
              <div style="margin-top: 0.5rem; font-weight: 600; color: #c68c4c;"></div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="delivery-option" style="margin-bottom: 1.5rem; padding: 1.5rem; border: 2px solid #e0e0e0; cursor: pointer;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div class="delivery-radio" style="width: 20px; height: 20px; border: 2px solid #ccc; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <div style="width: 10px; height: 10px; background: #c68c4c; border-radius: 50%; display: none;"></div>
          </div>
          <div>
            <div style="font-weight: 600; color: #333; margin-bottom: 0.5rem;">Consegna a Domicilio</div>
            <div style="font-size: 1.2rem; color: #666;">
              Consegna direttamente a casa tua con trasporto dedicato
              <div style="margin-top: 0.5rem; font-weight: 600; color: #c68c4c;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <input type="hidden" name="properties[${this.index}][Modalita_Consegna]" id="consegna-${this.index}" value="">
  `;
  
  // Inserisci dopo la tab verniciatura
  paintTab.parentNode.insertBefore(consegnaTab, paintTab.nextSibling);
  
  // Setup event listeners
  this.setupConsegnaOptions();

   this.updateTabsList();
}

addMontaggioTab() {
  const tabsContainer = this.productElement.querySelector('.estimator-tabs');
  const consegnaTab = this.productElement.querySelector(`[data-tab*="consegna-${this.index}"]`);
  
  if (!tabsContainer || !consegnaTab) return;
  
  const montaggioTab = document.createElement('div');
  montaggioTab.className = 'estimator-tab';
  montaggioTab.dataset.tab = `montaggio-${this.index}`;
  montaggioTab.innerHTML = `
    <label>Servizio di Montaggio</label>
    
    <div class="montaggio-options" style="margin: 2rem 0;">
      <div class="montaggio-option" style="margin-bottom: 1.5rem; padding: 1.5rem; border: 2px solid #e0e0e0; cursor: pointer;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div class="montaggio-radio" style="width: 20px; height: 20px; border: 2px solid #ccc; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <div style="width: 10px; height: 10px; background: #c68c4c; border-radius: 50%; display: none;"></div>
          </div>
          <div>
            <div style="font-weight: 600; color: #333; margin-bottom: 0.5rem;">Montaggio Professionale</div>
            <div style="font-size: 1.2rem; color: #666;">
              Montaggio completo da parte dei nostri tecnici specializzati
              <div style="margin-top: 0.5rem;">
                <div style="font-weight: 600; color: #c68c4c;"></div>
                <div style="font-size: 1.1rem; color: #28a745; margin-top: 0.25rem;">
                  ✓ Prodotto già montato e verificato<br>
                  ✓ Garantito contro imperfezioni<br>
                  ✓ Collaudo completo
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="montaggio-option" style="margin-bottom: 1.5rem; padding: 1.5rem; border: 2px solid #e0e0e0; cursor: pointer;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <div class="montaggio-radio" style="width: 20px; height: 20px; border: 2px solid #ccc; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <div style="width: 10px; height: 10px; background: #c68c4c; border-radius: 50%; display: none;"></div>
          </div>
          <div>
            <div style="font-weight: 600; color: #333; margin-bottom: 0.5rem;">Montaggio Fai da Te</div>
            <div style="font-size: 1.2rem; color: #666;">
              Monta tu stesso il prodotto seguendo le istruzioni
              <div style="margin-top: 0.5rem; font-weight: 600; color: #666;">Gratuito</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <input type="hidden" name="properties[${this.index}][Servizio_Montaggio]" id="montaggio-${this.index}" value="">
  `;
  
  // Inserisci dopo la tab consegna
  consegnaTab.parentNode.insertBefore(montaggioTab, consegnaTab.nextSibling);
  
  // Setup event listeners
  this.setupMontaggioOptions();

  this.updateTabsList();
}

setupConsegnaOptions() {
  const deliveryOptions = this.productElement.querySelectorAll('.delivery-option');
  const hiddenInput = this.productElement.querySelector(`#consegna-${this.index}`);
  
  deliveryOptions.forEach(option => {
    // Rimuovi event listener esistenti per evitare duplicati
    const newOption = option.cloneNode(true);
    option.parentNode.replaceChild(newOption, option);
  });

  // Riacquisisci gli elementi dopo il clone
  const freshDeliveryOptions = this.productElement.querySelectorAll('.delivery-option');
  
  freshDeliveryOptions.forEach(option => {
    option.addEventListener('click', () => {
      console.log('Click su opzione consegna');
      
      // Rimuovi selezione da tutte le opzioni
      freshDeliveryOptions.forEach(opt => {
        opt.style.borderColor = '#e0e0e0';
        opt.style.background = 'white';
        const radio = opt.querySelector('.delivery-radio div');
        if (radio) {
          radio.style.display = 'none';
        }
      });
      
      // Applica selezione all'opzione cliccata
      option.style.borderColor = '#c68c4c';
      option.style.background = '#fff8f0';
      const radio = option.querySelector('.delivery-radio div');
      if (radio) {
        radio.style.display = 'block';
        radio.style.background = '#c68c4c';
        radio.style.borderRadius = '50%';
      }
      
      // Imposta valore
      const optionText = option.querySelector('div > div:first-child').textContent.trim();
      if (hiddenInput) {
        hiddenInput.value = optionText;
      }
      
      console.log('Consegna selezionata:', optionText);
      this.saveData();
    });
  });
}

setupMontaggioOptions() {
  const montaggioOptions = this.productElement.querySelectorAll('.montaggio-option');
  const hiddenInput = this.productElement.querySelector(`#montaggio-${this.index}`);
  
  montaggioOptions.forEach(option => {
    // Rimuovi event listener esistenti per evitare duplicati
    const newOption = option.cloneNode(true);
    option.parentNode.replaceChild(newOption, option);
  });

  // Riacquisisci gli elementi dopo il clone
  const freshMontaggioOptions = this.productElement.querySelectorAll('.montaggio-option');
  
  freshMontaggioOptions.forEach(option => {
    option.addEventListener('click', () => {
      console.log('Click su opzione montaggio');
      
      // Rimuovi selezione da tutte le opzioni
      freshMontaggioOptions.forEach(opt => {
        opt.style.borderColor = '#e0e0e0';
        opt.style.background = 'white';
        const radio = opt.querySelector('.montaggio-radio div');
        if (radio) {
          radio.style.display = 'none';
        }
      });
      
      // Applica selezione all'opzione cliccata
      option.style.borderColor = '#c68c4c';
      option.style.background = '#fff8f0';
      const radio = option.querySelector('.montaggio-radio div');
      if (radio) {
        radio.style.display = 'block';
        radio.style.background = '#c68c4c';
        radio.style.borderRadius = '50%';
      }
      
      // Imposta valore
      const optionText = option.querySelector('div > div:first-child').textContent.trim();
      if (hiddenInput) {
        hiddenInput.value = optionText;
      }
      
      console.log('Montaggio selezionato:', optionText);
      this.saveData();
    });
  });
}

hideUnnecessaryTabs() {
  // Nascondi tessuti se non sono necessari
  const fabricTab = this.productElement.querySelector('[data-tab*="fabrics-"]');
  if (fabricTab) {
    fabricTab.style.display = 'none';
  }
  
  // Nascondi LED se non sono necessari
  const ledTab = this.productElement.querySelector('[data-tab*="led-"]');
  if (ledTab) {
    ledTab.style.display = 'none';
  }
}


  init() {
    // Se il prodotto non è completato, mostra il tab corrente
    if (!this.productElement.classList.contains('completed')) {
      this.showTab(this.currentTab);
    }
    this.bindEvents();
    //this.setupColorSelection();
    this.setupAdvancedColorSelection();
    this.setupFabricSelection();
    this.setupStructureLogic();
    this.setupMultiSelection();
    this.setupFileUpload();
    this.setupOptionalSelection();
    this.setupPhotoSuggestions();


      
    // Setup barra di progresso
    this.setupProgressBar();
     

    // Setup chiusure laterali solo per pergole
  if (this.productElement.querySelector('[data-tab^="side-closures-"]')) {
    this.setupSideClosures();
  }

  // AGGIUNTO: Forza l'aggiornamento iniziale dello stato pulsanti
    setTimeout(() => {
      this.updateSideButtonsState();
    }, 300);
  

    this.setupMeasuresListener();
    
    this.activateConditionalFields();
  }


// SOSTITUISCI completamente la funzione setupAdvancedColorSelection con questa versione semplificata
// SOSTITUISCI completamente la funzione setupAdvancedColorSelection con questa versione corretta
setupAdvancedColorSelection() {
  const colorItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2');
  const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
  
  if (!colorItems.length || !hiddenInput) return;

  console.log('Setup colori - trovati:', colorItems.length, 'elementi');

  // Rimuovi tutti gli event listener esistenti per evitare duplicati
  colorItems.forEach(item => {
    const newItem = item.cloneNode(true);
    if (item.parentNode) {
      item.parentNode.replaceChild(newItem, item);
    }
  });

  // Riacquisisci gli elementi dopo il clone
  const freshColorItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2');
  
  // Setup per colori semplici (senza tipo)
  const simpleColorItems = Array.from(freshColorItems).filter(item => !item.dataset.coloreType);
  if (simpleColorItems.length > 0) {
    this.setupSimpleColorSelection(simpleColorItems, hiddenInput);
  }

  // Setup per colori multipli (con tipo)
  const multipleColorItems = Array.from(freshColorItems).filter(item => item.dataset.coloreType);
  if (multipleColorItems.length > 0) {
    this.setupMultipleColorSelection(multipleColorItems, hiddenInput);
  }

  // Setup opzione "seleziona dopo"
  this.setupLaterColorSelection(hiddenInput);

  // CORREZIONE CRITICA: Ripristina immediatamente le selezioni dal valore salvato
  this.restoreColorSelectionsFromInput();
}

// AGGIUNGI QUESTA NUOVA FUNZIONE per ripristinare le selezioni dall'input
restoreColorSelectionsFromInput() {
  const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
  if (!hiddenInput || !hiddenInput.value) return;

  console.log('Ripristino colori da input:', hiddenInput.value);

  // Se è "seleziona dopo", attiva quella opzione
  if (hiddenInput.value.includes('in seguito')) {
    this.setLaterColorSelection();
    return;
  }

  // Se sono colori multipli (contiene |)
  if (hiddenInput.value.includes('|')) {
    const selections = hiddenInput.value.split(' | ');
    this.selectedColors = {};
    
    selections.forEach(selection => {
      const match = selection.match(/(.+): (.+)/);
      if (match) {
        const type = match[1].trim();
        const colorName = match[2].trim();
        this.selectedColors[type] = colorName;
        
        // Trova e seleziona visivamente l'elemento
        const item = this.productElement.querySelector(`.color-item-collapsible-row-2[data-colore-type="${type}"][data-colore-name="${colorName}"]`);
        if (item) {
          item.classList.add('selected');
          console.log('Colore selezionato visivamente:', type, colorName);
        }
      }
    });
  } 
  // Se è un colore singolo
  else if (!hiddenInput.value.includes('in seguito')) {
    const colorItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2:not([data-colore-type])');
    colorItems.forEach(item => {
      const colorName = item.querySelector('.color-name-collapsible-row-2')?.textContent || '';
      if (hiddenInput.value.includes(colorName)) {
        item.classList.add('selected');
        console.log('Colore singolo selezionato visivamente:', colorName);
      }
    });
  }
}

// VERSIONE SEMPLIFICATA per colori singoli
setupSimpleColorSelection(colorItems, hiddenInput) {
  colorItems.forEach(item => {
    item.addEventListener('click', () => {
      // Rimuovi selezione da tutti i colori semplici
      colorItems.forEach(i => i.classList.remove('selected'));
      
      // Aggiungi selezione al corrente
      item.classList.add('selected');
      
      // Aggiorna input hidden
      const colorName = item.querySelector('.color-name-collapsible-row-2')?.textContent || '';
      const colorCode = item.querySelector('.color-code-collapsible-row-2')?.textContent || '';
      hiddenInput.value = `${colorName} (${colorCode})`;
      
      this.resetLaterColorSelection();
      this.saveData();
    });
  });
}

// VERSIONE SEMPLIFICATA per colori multipli
setupMultipleColorSelection(colorItems, hiddenInput) {
  this.selectedColors = this.selectedColors || {};

  colorItems.forEach(item => {
    item.addEventListener('click', () => {
      const colorType = item.dataset.coloreType;
      const colorName = item.dataset.coloreName;
      
      if (!colorType) return;

      // Se già selezionato, deseleziona
      if (this.selectedColors[colorType] === colorName) {
        item.classList.remove('selected');
        delete this.selectedColors[colorType];
      } else {
        // Rimuovi selezione precedente per questo tipo
        const sameTypeItems = colorItems.filter(i => i.dataset.coloreType === colorType);
        sameTypeItems.forEach(i => i.classList.remove('selected'));
        
        // Seleziona nuovo
        item.classList.add('selected');
        this.selectedColors[colorType] = colorName;
      }

      // Aggiorna input
      this.updateColorSelectionInput(hiddenInput);
      this.resetLaterColorSelection();
      this.saveData();
    });
  });
}

// VERSIONE SEMPLIFICATA per aggiornare input
updateColorSelectionInput(hiddenInput) {
  if (!this.selectedColors || Object.keys(this.selectedColors).length === 0) {
    hiddenInput.value = '';
    return;
  }

  const selections = [];
  Object.keys(this.selectedColors).forEach(type => {
    if (this.selectedColors[type]) {
      selections.push(`${type}: ${this.selectedColors[type]}`);
    }
  });

  hiddenInput.value = selections.join(' | ');
}

// VERSIONE SEMPLIFICATA per "seleziona dopo"
setupLaterColorSelection(hiddenInput) {
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  if (!laterColorToggle) return;

  // Rimuovi e ricrea per pulire event listeners
  const newToggle = laterColorToggle.cloneNode(true);
  laterColorToggle.parentNode.replaceChild(newToggle, laterColorToggle);
  
  const freshToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  
  freshToggle.addEventListener('click', () => {
    // Deseleziona tutti i colori
    this.productElement.querySelectorAll('.color-item-collapsible-row-2').forEach(item => {
      item.classList.remove('selected');
    });
    
    this.selectedColors = {};
    hiddenInput.value = 'Colori da selezionare in seguito';
    this.setLaterColorSelection();
    this.saveData();
  });
}

// MANTIENI QUESTE FUNZIONI COME SONO (funzionano già bene)
setLaterColorSelection() {
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  if (!laterColorToggle) return;

  laterColorToggle.style.borderColor = '#c68c4c';
  laterColorToggle.style.background = '#fff8f0';
  laterColorToggle.querySelector('.checkmark').style.background = '#c68c4c';
  laterColorToggle.querySelector('.checkmark').style.borderColor = '#c68c4c';
  laterColorToggle.querySelector('.checkmark svg').style.opacity = '1';
}

resetLaterColorSelection() {
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  if (!laterColorToggle) return;

  laterColorToggle.style.borderColor = '#e0e0e0';
  laterColorToggle.style.background = '#f9f9f9';
  laterColorToggle.querySelector('.checkmark').style.background = 'transparent';
  laterColorToggle.querySelector('.checkmark').style.borderColor = '#ccc';
  laterColorToggle.querySelector('.checkmark svg').style.opacity = '0';
}



  // ---------------- GESTIONE TABS INTELLIGENTE ----------------

showTab(index) {
  console.log('🎯 Showing tab:', index, 'of', this.tabs.length);
  
  // Trova la prima tab visibile se quella corrente non lo è
  if (!this.isTabVisible(this.tabs[index])) {
    console.log('❌ Tab non visibile, cerco prima tab visibile...');
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.isTabVisible(this.tabs[i])) {
        index = i;
        this.currentTab = i;
        console.log('✅ Trovata tab visibile:', i);
        break;
      }
    }
  }
  
  // NASCONDI TUTTE LE TAB
  this.tabs.forEach(tab => {
    tab.classList.remove('active');
    tab.style.display = 'none';
  });

  // MOSTRA SOLO LA TAB CORRENTE
  if (this.tabs[index]) {
    this.tabs[index].classList.add('active');
    this.tabs[index].style.display = 'block';
    console.log('✅ Tab mostrata:', this.tabs[index].dataset.tab);
  }

  this.updateNavigation();
  this.updateProgressBar();
}

  // VERIFICA SE UNA TAB È VISIBILE

isTabVisible(tab) {
  // Se la tab è marchiata come nascosta per arredo, non è visibile
  if (tab.hasAttribute('data-hidden-for-arredo')) {
    return false;
  }
  
  const tabType = tab.dataset.tab;
  
  // Logica originale per altri prodotti (mantieni solo questa parte)
  if (tabType.includes('attachment')) {
    const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
    return structureSelect && structureSelect.value === 'Addossata';
  }

  if (tabType.includes('side-closures')) {
    return this.productElement.querySelector('[data-tab^="side-closures-"]') !== null;
  }
  
  if (tabType.includes('existing-structure')) {
    const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
    return structureSelect && structureSelect.value === 'Solo Copertura';
  }
  
  return true;
}

  // TROVA E MOSTRA LA PROSSIMA TAB VISIBILE
  findAndShowNextVisibleTab(startIndex) {
    const visibleTabs = this.getVisibleTabs();
    
    if (visibleTabs.length === 0) {
      console.error('Nessuna tab visibile trovata');
      return;
    }
    
    // Trova l'indice della tab corrente tra quelle visibili
    const currentVisibleIndex = visibleTabs.findIndex(tab => 
      tab.classList.contains('active')
    );
    
    let nextIndex;
    if (currentVisibleIndex >= 0 && currentVisibleIndex < visibleTabs.length - 1) {
      // Vai alla prossima tab visibile
      nextIndex = Array.from(this.tabs).indexOf(visibleTabs[currentVisibleIndex + 1]);
    } else if (currentVisibleIndex === -1) {
      // Nessuna tab attiva, mostra la prima visibile
      nextIndex = Array.from(this.tabs).indexOf(visibleTabs[0]);
    } else {
      // Ultima tab, completa
      this.completeProduct();
      return;
    }
    
    this.currentTab = nextIndex;
    this.showTab(this.currentTab);
  }

  // OTTIENI TUTTE LE TAB VISIBILI
  getVisibleTabs() {
    return Array.from(this.tabs).filter(tab => this.isTabVisible(tab));
  }

  // AGGIORNA LA NAVIGAZIONE (BOTTONE INDIETRO)
  updateNavigation() {
    const prevBtn = this.productElement.querySelector('.prev-tab');
    if (prevBtn) {
      // Mostra il bottone indietro solo se non siamo sulla prima tab
      const visibleTabs = this.getVisibleTabs();
      const currentVisibleIndex = visibleTabs.findIndex(tab => 
        tab.classList.contains('active')
      );
      
      prevBtn.style.visibility = currentVisibleIndex > 0 ? 'visible' : 'hidden';
    }
  }

// NAVIGAZIONE MIGLIORATA
// NAVIGAZIONE MIGLIORATA
nextTab() {
  if (this.validateCurrentTab()) {
    this.saveData();
    
    const visibleTabs = this.getVisibleTabs();
    const currentVisibleIndex = visibleTabs.findIndex(tab => 
      tab.classList.contains('active')
    );
    
    console.log('NextTab - corrente:', currentVisibleIndex, 'totale:', visibleTabs.length);
    
    if (currentVisibleIndex < visibleTabs.length - 1) {
      // Vai alla prossima tab visibile
      const nextVisibleTab = visibleTabs[currentVisibleIndex + 1];
      const nextGlobalIndex = Array.from(this.tabs).indexOf(nextVisibleTab);
      this.currentTab = nextGlobalIndex;
      this.showTab(this.currentTab);
      
      // SCROLL ALL'INIZIO DELLA TAB
      this.scrollToTabTop();
      
      console.log('Andando al tab:', this.currentTab);
    } else {
      // Ultima tab visibile - completa
      console.log('Completando prodotto');
      this.completeProduct();
    }
    
    // FORZA AGGIORNAMENTO BARRA
    this.updateProgressBar();
  }
}

prevTab() {
  const visibleTabs = this.getVisibleTabs();
  const currentVisibleIndex = visibleTabs.findIndex(tab => 
    tab.classList.contains('active')
  );
  
  console.log('PrevTab - corrente:', currentVisibleIndex);
  
  if (currentVisibleIndex > 0) {
    // Vai alla tab precedente visibile
    const prevVisibleTab = visibleTabs[currentVisibleIndex - 1];
    const prevGlobalIndex = Array.from(this.tabs).indexOf(prevVisibleTab);
    this.currentTab = prevGlobalIndex;
    this.showTab(this.currentTab);
    
    // SCROLL ALL'INIZIO DELLA TAB
    this.scrollToTabTop();
    
    console.log('Andando al tab:', this.currentTab);
  }
  
  // FORZA AGGIORNAMENTO BARRA
  this.updateProgressBar();
}

// ---------------- SCROLL ALL'INIZIO DELLA TAB ----------------
scrollToTabTop() {
  // Aspetta che la tab sia renderizzata
  setTimeout(() => {
    const currentTab = this.tabs[this.currentTab];
    if (currentTab) {
      // Cerca il PRIMO ELEMENTO qualsiasi nella tab corrente
      const firstElement = currentTab.querySelector('*');
      
      if (firstElement) {
        // Calcola la posizione del primo elemento e sottrai 100px
        const elementPosition = firstElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 200; // 100px più su
        
        // Scroll alla posizione calcolata
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        console.log('Scroll a 100px sopra il primo elemento:', firstElement.tagName, firstElement.textContent?.substring(0, 30));
      } else {
        // Fallback: scroll all'inizio della tab se non trova elementi
        currentTab.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start'
        });
        console.log('Nessun elemento trovato, scroll alla tab');
      }
    }
  }, 150);
}

  validateCurrentTab() {
    const currentTab = this.tabs[this.currentTab];
    if (!currentTab || currentTab.style.display === 'none') return true;
    
    let valid = true;
    
    currentTab.querySelectorAll('[required]').forEach(f => {
      if (!f.value.trim()) {
        f.style.border = '1px solid red';
        valid = false;
      } else {
        f.style.border = '';
      }
    });
    
    return valid;
  }

  // ---------------- GESTIONE STRUTTURA E ATTACCO ----------------
setupStructureLogic() {
  const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
  if (!structureSelect) return;

  structureSelect.addEventListener('change', (e) => {
    const selectedStructure = e.target.value;
    console.log('Struttura cambiata:', selectedStructure);
    this.handleStructureChange(selectedStructure);
    // AGGIORNA BARRA QUANDO CAMBIA LA STRUTTURA
    setTimeout(() => this.updateProgressBar(), 200);
  });

  if (structureSelect.value) {
    this.handleStructureChange(structureSelect.value);
  }
}


  handleStructureChange(structureType) {
    console.log('Structure changed to:', structureType);
    
    // Salva subito i dati
    this.saveData();
    
    // Ricalcola la visibilità delle tab e mostra quella corretta
    const visibleTabs = this.getVisibleTabs();
    const currentVisibleIndex = visibleTabs.findIndex(tab => 
      tab.classList.contains('active')
    );
    
    // Se la tab corrente non è più visibile, trova la prima tab visibile
    if (currentVisibleIndex === -1 && visibleTabs.length > 0) {
      const firstVisibleIndex = Array.from(this.tabs).indexOf(visibleTabs[0]);
      this.currentTab = firstVisibleIndex;
    }
    
    this.showTab(this.currentTab);
  }

setupAttachmentLogic() {
  const attachmentSelect = this.productElement.querySelector(`#attachment-type-${this.index}`);
  if (!attachmentSelect) return;

  attachmentSelect.addEventListener('change', (e) => {
    const attachmentType = e.target.value;
    console.log('Attacco cambiato:', attachmentType);
    this.handleAttachmentChange(attachmentType);
    // AGGIORNA BARRA QUANDO CAMBIA L'ATTACCO
    setTimeout(() => this.updateProgressBar(), 200);
  });

  if (attachmentSelect.value) {
    this.handleAttachmentChange(attachmentSelect.value);
  }
}

  handleAttachmentChange(attachmentType) {
    console.log('Attachment changed to:', attachmentType);
    
    const cappottoField = this.productElement.querySelector(`#cappotto-field-${this.index}`);
    const ingombriField = this.productElement.querySelector(`#ingombri-field-${this.index}`);

    // NASCONDI I CAMPI
    if (cappottoField) cappottoField.style.display = 'none';
    if (ingombriField) ingombriField.style.display = 'none';

    // SOLO per "Parete" mostra cappotto e ingombri
    if (attachmentType === 'Parete') {
      if (cappottoField) cappottoField.style.display = 'block';
      if (ingombriField) ingombriField.style.display = 'block';
    }

    this.saveData();
  }

  setupCappottoLogic() {
    const cappottoSelect = this.productElement.querySelector(`#cappotto-select-${this.index}`);
    if (!cappottoSelect) return;

    cappottoSelect.addEventListener('change', (e) => {
      const hasCappotto = e.target.value === 'si';
      this.handleCappottoChange(hasCappotto);
    });

    if (cappottoSelect.value) {
      this.handleCappottoChange(cappottoSelect.value === 'si');
    }
  }

  handleCappottoChange(hasCappotto) {
    const spessoreField = this.productElement.querySelector(`#spessore-field-${this.index}`);
    
    if (spessoreField) {
      spessoreField.style.display = hasCappotto ? 'block' : 'none';
    }
    
    this.saveData();
  }

  // ---------------- GESTIONE SUGGERIMENTI FOTO ----------------
  setupPhotoSuggestions() {
    const structureSelect = this.productElement.querySelector(`#structure-type-${this.index}`);
    const attachmentSelect = this.productElement.querySelector(`#attachment-type-${this.index}`);
    
    if (structureSelect) {
      structureSelect.addEventListener('change', () => this.updatePhotoSuggestions());
    }
    if (attachmentSelect) {
      attachmentSelect.addEventListener('change', () => this.updatePhotoSuggestions());
    }
    
    this.updatePhotoSuggestions();
  }

  updatePhotoSuggestions() {
    const suggestionsContainer = this.productElement.querySelector(`#photo-suggestions-${this.index}`);
    const suggestionContent = this.productElement.querySelector(`#suggestion-content-${this.index}`);
    
    if (!suggestionsContainer || !suggestionContent) return;

    const structureType = this.productElement.querySelector(`#structure-type-${this.index}`)?.value;
    const attachmentType = this.productElement.querySelector(`#attachment-type-${this.index}`)?.value;

    let suggestionsHTML = '';

    if (structureType === 'Addossata' && attachmentType === 'Parete') {
      suggestionsHTML = `
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li style="margin-bottom: 0.5rem;">✅ <strong>Foto della parete</strong> dove verrà installata</li>
          <li style="margin-bottom: 0.5rem;">✅ <strong>Dettaglio del muro</strong> per valutare il fissaggio</li>
        </ul>
      `;
    } else if (structureType === 'Addossata' && attachmentType === 'Soffitto') {
      suggestionsHTML = `
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li style="margin-bottom: 0.5rem;">✅ <strong>Foto del soffitto</strong> dove verrà installata</li>
          <li style="margin-bottom: 0.5rem;">✅ <strong>Dettaglio del punto di fissaggio</strong></li>
        </ul>
      `;
    } else if (structureType === 'Autoportante') {
      suggestionsHTML = `
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li style="margin-bottom: 0.5rem;">✅ <strong>Foto dell'area</strong> dove verrà posizionata</li>
          <li style="margin-bottom: 0.5rem;">✅ <strong>Superficie del terreno</strong></li>
        </ul>
      `;
    } else if (structureType === 'Solo Copertura') {
      suggestionsHTML = `
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li style="margin-bottom: 0.5rem;">✅ <strong>Foto della struttura esistente</strong></li>
          <li style="margin-bottom: 0.5rem;">✅ <strong>Dettaglio dei punti di attacco</strong></li>
        </ul>
      `;
    }

    if (suggestionsHTML) {
      suggestionsContainer.style.display = 'block';
      suggestionContent.innerHTML = suggestionsHTML;
    } else {
      suggestionsContainer.style.display = 'none';
    }
  }

// ---------------- BIND EVENTS (con salvataggio) ----------------
bindEvents() {
  const nextBtn = this.productElement.querySelector('.next-tab');
  const prevBtn = this.productElement.querySelector('.prev-tab');
  const editBtn = this.productElement.querySelector('.edit-product');

  if (nextBtn) nextBtn.addEventListener('click', () => {
    if (this.validateCurrentTab()) {
      this.saveData();
      this.nextTab();
      // AGGIORNA BARRA DOPO AVANTI
      setTimeout(() => this.updateProgressBar(), 100);
    }
  });

  if (prevBtn) prevBtn.addEventListener('click', () => {
    this.saveData();
    this.prevTab();
    // AGGIORNA BARRA DOPO INDIETRO
    setTimeout(() => this.updateProgressBar(), 100);
  });

  if (editBtn) editBtn.addEventListener('click', () => this.editProduct());

  // Salva dati quando cambiano gli input
  this.productElement.querySelectorAll('input, select, textarea').forEach(input => {
    if (input.type === 'file') return;
    
    input.addEventListener('change', () => {
      this.saveData();
      if (input.tagName === 'SELECT') {
        this.activateConditionalFields();
      }
    });
    input.addEventListener('input', () => this.saveData());
  });

  // Setup per il pulsante aggiungi misura
  const addMeasureBtn = this.productElement.querySelector('.add-another-measure');
  if (addMeasureBtn) {
    addMeasureBtn.addEventListener('click', () => this.addAnotherMeasure());
  }

  this.setupConditionalFields();
}

  setupConditionalFields() {
    const attachment = document.getElementById(`attachment-type-${this.index}`);
    if (attachment) {
      attachment.addEventListener('change', e => {
        const obs = document.getElementById(`ingombri-field-${this.index}`);
        const cappotto = document.getElementById(`cappotto-field-${this.index}`);
        if (obs) obs.style.display = e.target.value === 'Parete' ? 'block' : 'none';
        if (cappotto) cappotto.style.display = e.target.value === 'Parete' ? 'block' : 'none';
      });
    }

    this.activateConditionalFields();
  }

  // ---------------- FILE UPLOAD (MULTIPLE FILE) ----------------
  setupFileUpload() {
    this.setupFileUploadEvents();
    setTimeout(() => {
      this.loadSavedFiles();
    }, 100);
  }

  loadSavedFiles() {
    const savedFiles = localStorage.getItem(`estimator_files_${this.uniqueProductId}`);
    if (!savedFiles) return;

    try {
      const filesData = JSON.parse(savedFiles);
      if (filesData && filesData.length > 0) {
        this.recreateFilePreviews(filesData);
      }
    } catch (error) {
      console.error('Errore nel caricamento file salvati:', error);
    }
  }

  saveFiles() {
    const previewContainer = this.productElement.querySelector('.image-preview-container');
    if (!previewContainer) return;

    const filesData = [];
    const previewItems = previewContainer.querySelectorAll('.image-preview-item');
    
    previewItems.forEach(previewItem => {
      const img = previewItem.querySelector('.image-preview-img');
      const nameElement = previewItem.querySelector('.image-preview-name');
      
      if (img && img.src.startsWith('data:') && nameElement) {
        filesData.push({
          name: nameElement.textContent,
          data: img.src
        });
      }
    });

    if (filesData.length > 0) {
      localStorage.setItem(`estimator_files_${this.uniqueProductId}`, JSON.stringify(filesData));
    } else {
      localStorage.removeItem(`estimator_files_${this.uniqueProductId}`);
    }
  }

  recreateFilePreviews(filesData) {
    const previewContainer = this.productElement.querySelector('.image-preview-container');
    if (!previewContainer) return;

    previewContainer.innerHTML = '';
    
    filesData.forEach((fileData, index) => {
      const previewItem = document.createElement('div');
      previewItem.className = 'image-preview-item';
      previewItem.innerHTML = `
        <img src="${fileData.data}" alt="${fileData.name}" class="image-preview-img">
        <button type="button" class="image-preview-remove" data-filename="${fileData.name}">×</button>
        <div class="image-preview-name">${fileData.name}</div>
      `;
      previewContainer.appendChild(previewItem);

      previewItem.querySelector('.image-preview-remove').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.removeFileByName(fileData.name);
      });
    });
  }

setupFileUploadEvents() {
  const fileInput = this.productElement.querySelector('.file-input');
  const fileUploadArea = this.productElement.querySelector('.file-upload-area');
  const uploadButton = this.productElement.querySelector('.file-upload-button');

  if (!fileInput) return;

  fileInput.setAttribute('multiple', 'multiple');
  fileInput.setAttribute('accept', 'image/*, .heic, .HEIC'); // Accetta HEIC

  if (fileUploadArea) {
    fileUploadArea.addEventListener('click', e => {
      if (!uploadButton || e.target !== uploadButton) fileInput.click();
    });
  }

  if (uploadButton) {
    uploadButton.addEventListener('click', () => fileInput.click());
  }

  if (fileUploadArea) {
    fileUploadArea.addEventListener('dragover', e => {
      e.preventDefault();
      fileUploadArea.classList.add('dragover');
    });

    fileUploadArea.addEventListener('dragleave', () => {
      fileUploadArea.classList.remove('dragover');
    });

    fileUploadArea.addEventListener('drop', e => {
      e.preventDefault();
      fileUploadArea.classList.remove('dragover');
      
      const newFiles = Array.from(e.dataTransfer.files);
      if (newFiles.length > 0) {
        this.addFilesToPreview(newFiles);
      }
    });
  }

  fileInput.addEventListener('change', e => {
    if (e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      this.addFilesToPreview(newFiles).finally(() => {
        fileInput.value = ''; // Reset input
      });
    }
  });
}

// ---------------- GESTIONE UPLOAD CON PROCESSAMENTO ----------------
async addFilesToPreview(newFiles) {
  const previewContainer = this.productElement.querySelector('.image-preview-container');
  if (!previewContainer) return;

  const existingNames = Array.from(previewContainer.querySelectorAll('.image-preview-name'))
    .map(nameElement => nameElement.textContent.split(' (')[0]); // Rimuovi la dimensione dal nome

  let filesAdded = 0;
  const MAX_FILES = 15;
  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB limite originale

  // Conta files attuali
  const currentFileCount = previewContainer.querySelectorAll('.image-preview-item').length;
  
  if (currentFileCount + newFiles.length > MAX_FILES) {
    alert(`Puoi caricare massimo ${MAX_FILES} immagini. Attualmente hai ${currentFileCount} file.`);
    return;
  }

  // Mostra indicatore di caricamento
  this.showUploadProgress(newFiles.length);

  for (const [index, file] of newFiles.entries()) {
    // Aggiorna progresso
    this.updateUploadProgress(index + 1, newFiles.length, `Processando: ${file.name}`);

    if (!file.type.startsWith('image/')) {
      // Supporta HEIC
      if (file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic')) {
        // Procedi con HEIC
      } else {
        alert(`Il file "${file.name}" non è un'immagine supportata. Formati supportati: JPEG, PNG, HEIC.`);
        continue;
      }
    }

    if (file.size > MAX_FILE_SIZE) {
      alert(`Il file "${file.name}" è troppo grande (${(file.size / 1024 / 1024).toFixed(1)}MB). Massimo consentito: 20MB.`);
      continue;
    }

    if (existingNames.includes(file.name)) {
      console.log('File già presente:', file.name);
      continue;
    }

    try {
      // STEP 1: Processa il file (conversione HEIC + compressione)
      const processedFile = await this.processImageFile(file);
      
      // STEP 2: Crea preview
      await this.createFilePreview(processedFile, file.name, previewContainer);
      
      filesAdded++;

    } catch (error) {
      console.error(`Errore processamento ${file.name}:`, error);
      alert(`Errore con il file "${file.name}": ${error.message}`);
      
      // Fallback: prova a creare preview con file originale
      try {
        await this.createFilePreview(file, file.name, previewContainer);
        filesAdded++;
      } catch (fallbackError) {
        console.error('Fallback failed:', fallbackError);
      }
    }
  }

  // Nascondi indicatore di caricamento
  this.hideUploadProgress();

  if (filesAdded > 0) {
    this.saveFiles();
    console.log(`Aggiunti ${filesAdded} files processati`);
  }
}

  removeFileByName(filename) {
    const previewContainer = this.productElement.querySelector('.image-preview-container');
    if (!previewContainer) return;

    const previewItems = previewContainer.querySelectorAll('.image-preview-item');
    
    previewItems.forEach(previewItem => {
      const nameElement = previewItem.querySelector('.image-preview-name');
      if (nameElement && nameElement.textContent === filename) {
        previewItem.remove();
        this.saveFiles();
        return;
      }
    });
  }

  removeFile(index) {
    const previewContainer = this.productElement.querySelector('.image-preview-container');
    if (!previewContainer) return;

    const previewItems = previewContainer.querySelectorAll('.image-preview-item');
    if (previewItems[index]) {
      const nameElement = previewItems[index].querySelector('.image-preview-name');
      if (nameElement) {
        this.removeFileByName(nameElement.textContent);
      }
    }
  }

  handleFileSelection(files) {
    this.addFilesToPreview(Array.from(files));
  }

  // ---------------- GESTIONE COLORI E TESSUTI ----------------


  setupFabricSelection() {
    const fabricItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2[data-tessuto-name]');
    const hiddenInput = this.productElement.querySelector(`#tessuto-${this.index}`);
    const laterFabricToggle = this.productElement.querySelector('.color-later-toggle[data-type="tessuto"]');

    if (!fabricItems.length || !hiddenInput) return;

    fabricItems.forEach(item => {
      item.addEventListener('click', () => {
        fabricItems.forEach(i => i.classList.remove('selected'));
        item.classList.add('selected');

        const fabricName = item.dataset.tessutoName;
        const fabricCode = item.dataset.tessutoCode;
        hiddenInput.value = `${fabricName} (${fabricCode})`;

        this.resetLaterFabricSelection();
        this.saveData();
      });
    });

    if (laterFabricToggle) {
      laterFabricToggle.addEventListener('click', () => {
        fabricItems.forEach(i => i.classList.remove('selected'));
        hiddenInput.value = 'Tessuto da selezionare in seguito';
        this.setLaterFabricSelection();
        this.saveData();
      });
    }
  }

  setLaterColorSelection() {
    const laterColorToggle = this.productElement.querySelector('.color-later-toggle:not([data-type="tessuto"])');
    if (!laterColorToggle) return;

    const checkmark = laterColorToggle.querySelector('.checkmark');
    const svg = checkmark.querySelector('svg');

    laterColorToggle.style.borderColor = '#c68c4c';
    laterColorToggle.style.background = '#fff8f0';
    checkmark.style.background = '#c68c4c';
    checkmark.style.borderColor = '#c68c4c';
    svg.style.opacity = '1';

    this.productElement.classList.add('color-later-selected');
  }

  resetLaterColorSelection() {
    const laterColorToggle = this.productElement.querySelector('.color-later-toggle:not([data-type="tessuto"])');
    if (!laterColorToggle) return;

    const checkmark = laterColorToggle.querySelector('.checkmark');
    const svg = checkmark.querySelector('svg');

    laterColorToggle.style.borderColor = '#e0e0e0';
    laterColorToggle.style.background = '#f9f9f9';
    checkmark.style.background = 'transparent';
    checkmark.style.borderColor = '#ccc';
    svg.style.opacity = '0';

    this.productElement.classList.remove('color-later-selected');
  }

  setLaterFabricSelection() {
    const laterFabricToggle = this.productElement.querySelector('.color-later-toggle[data-type="tessuto"]');
    if (!laterFabricToggle) return;

    const checkmark = laterFabricToggle.querySelector('.checkmark');
    const svg = checkmark.querySelector('svg');

    laterFabricToggle.style.borderColor = '#c68c4c';
    laterFabricToggle.style.background = '#fff8f0';
    checkmark.style.background = '#c68c4c';
    checkmark.style.borderColor = '#c68c4c';
    svg.style.opacity = '1';

    laterFabricToggle.closest('.color-later-option').classList.add('color-later-selected');
  }

  resetLaterFabricSelection() {
    const laterFabricToggle = this.productElement.querySelector('.color-later-toggle[data-type="tessuto"]');
    if (!laterFabricToggle) return;

    const checkmark = laterFabricToggle.querySelector('.checkmark');
    const svg = checkmark.querySelector('svg');

    laterFabricToggle.style.borderColor = '#e0e0e0';
    laterFabricToggle.style.background = '#f9f9f9';
    checkmark.style.background = 'transparent';
    checkmark.style.borderColor = '#ccc';
    svg.style.opacity = '0';

    laterFabricToggle.closest('.color-later-option').classList.remove('color-later-selected');
  }

  // ---------------- GESTIONE MULTISELETIONE ----------------
  setupMultiSelection() {
    this.setupLEDSelection();
  }

  setupLEDSelection() {
    const ledCards = this.productElement.querySelectorAll('.optional-card[data-type="led"]');
    const hiddenInput = this.productElement.querySelector(`#led-values-${this.index}`);
    
    if (!ledCards.length || !hiddenInput) return;

    this.initializeMultiSelection(ledCards, hiddenInput, 'led');
  }

  setupOptionalSelection() {
    const metafieldCards = this.productElement.querySelectorAll('.optional-card[data-type="metafield"]');
    const metafieldInput = this.productElement.querySelector(`#optional-metafield-${this.index}`);
    if (metafieldCards.length && metafieldInput) {
      this.initializeMultiSelection(metafieldCards, metafieldInput, 'metafield');
    }

    const fixedCards = this.productElement.querySelectorAll('.optional-card[data-type="fixed"]');
    const fixedInput = this.productElement.querySelector(`#optional-fixed-${this.index}`);
    if (fixedCards.length && fixedInput) {
      this.initializeMultiSelection(fixedCards, fixedInput, 'fixed');
    }
  }

  initializeMultiSelection(cards, hiddenInput, type) {
    const selectedOptions = new Set(hiddenInput.value ? hiddenInput.value.split(', ').filter(opt => opt !== '') : []);

    cards.forEach(card => {
      const val = card.dataset.optional;
      const checkbox = card.querySelector('.optional-checkbox');
      const svg = checkbox.querySelector('svg');

      if (selectedOptions.has(val)) {
        card.classList.add('selected');
        card.style.borderColor = '#c68c4c';
        card.style.background = '#fff8f0';
        checkbox.style.background = '#c68c4c';
        checkbox.style.borderColor = '#c68c4c';
        svg.style.opacity = '1';
      }

      card.addEventListener('click', () => {
        if (selectedOptions.has(val)) {
          selectedOptions.delete(val);
          card.classList.remove('selected');
          card.style.borderColor = '#e0e0e0';
          card.style.background = '#fff';
          checkbox.style.background = 'transparent';
          checkbox.style.borderColor = '#ccc';
          svg.style.opacity = '0';
        } else {
          selectedOptions.add(val);
          card.classList.add('selected');
          card.style.borderColor = '#c68c4c';
          card.style.background = '#fff8f0';
          checkbox.style.background = '#c68c4c';
          checkbox.style.borderColor = '#c68c4c';
          svg.style.opacity = '1';
        }

        hiddenInput.value = Array.from(selectedOptions).join(', ');
        this.saveData();
      });
    });

    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        if (!card.classList.contains('selected')) {
          card.style.borderColor = '#c68c4c';
          card.style.background = '#f9f9f9';
        }
      });
      card.addEventListener('mouseleave', () => {
        if (!card.classList.contains('selected')) {
          card.style.borderColor = '#e0e0e0';
          card.style.background = '#fff';
        }
      });
    });
  }

  restoreMultiSelectionState(selector, values) {
    const options = values.split(', ').filter(opt => opt !== '');
    this.productElement.querySelectorAll(selector).forEach(card => {
      const val = card.dataset.optional;
      if (options.includes(val)) {
        card.classList.add('selected');
        card.style.borderColor = '#c68c4c';
        card.style.background = '#fff8f0';
        const checkbox = card.querySelector('.optional-checkbox');
        const svg = checkbox.querySelector('svg');
        checkbox.style.background = '#c68c4c';
        checkbox.style.borderColor = '#c68c4c';
        svg.style.opacity = '1';
      }
    });
  }

fillRecap() {
  if (!this.recapContent) return;
  
  this.recapContent.innerHTML = '';

  // FILE PREVIEW - codice esistente...
  const fileInput = this.productElement.querySelector('.file-input');
  if (fileInput && fileInput.files.length > 0) {
    const p = document.createElement('p');
    p.innerHTML = `<strong>Foto caricate:</strong> ${fileInput.files.length} immagine(i)`;
    this.recapContent.appendChild(p);

    const previewContainer = document.createElement('div');
    previewContainer.style.display = 'grid';
    previewContainer.style.gridTemplateColumns = 'repeat(auto-fit, minmax(80px, 1fr))';
    previewContainer.style.gap = '0.5rem';
    previewContainer.style.marginTop = '0.5rem';

    Array.from(fileInput.files).forEach(file => {
      const reader = new FileReader();
      reader.onload = e => {
        const img = document.createElement('img');
        img.src = e.target.result;
        img.style.width = '100%';
        img.style.height = '80px';
        img.style.objectFit = 'cover';
        img.style.border = '2px solid #ccc';
        previewContainer.appendChild(img);
      };
      reader.readAsDataURL(file);
    });
    this.recapContent.appendChild(previewContainer);
  }

  // Leggi direttamente i valori dagli input invece di ricostruirli
  const inputs = this.productElement.querySelectorAll('input, select, textarea');
  inputs.forEach(input => {
    if (input.type === 'file' || !input.name || 
        input.name =="product_id" || input.name =="variant_id" || 
        input.name=="title"|| input.name =="product[Tags_Prodotto]" || 
        input.name.toLowerCase().includes("[chiusure_laterali]")) return;

    let label = "";
    let value = input.value; // USA SEMPRE IL VALORE DELL'INPUT

    // CORREZIONE: Per verniciatura, usa direttamente il valore già formattato
    if(input.name.toLowerCase().includes("[verniciatura]")) {
      label = "Verniciatura";
      // value rimane "tavolo: Rastin | sedia: Barn" - GIÀ CORRETTO!
      console.log('Recap - Verniciatura:', value);
    }
    // Gestione altri casi speciali...
    else if(input.name.toLowerCase().includes("[modalita_consegna]")) {
      label = "Consegna";
      value = input.value.includes("Ritiro in Sede") ? "Ritiro in Sede" : "Consegna a Domicilio";
    }
    else if(input.name.toLowerCase().includes("[servizio_montaggio]")) {
      label = "Montaggio";
      value = input.value.includes("Professionale") ? "Professionale" : "Fai da te";
    }
    else {
      label = input.previousElementSibling?.textContent ||
              input.closest('label')?.textContent ||
              input.name.split('[').pop().replace(']','').replace('_', ' ');
    }

    // Gestione optional
    if ((input.id === `optional-metafield-${this.index}` || input.id === `optional-fixed-${this.index}` || input.id === `led-values-${this.index}`) && value) {
      const type = input.id.includes('metafield') ? 'Optional' : 
                  input.id.includes('fixed') ? 'Optional fissi' : 'LED';
      label = type;
      const options = value.split(', ');
      value = options.map(opt => `<span style="background:#fff8f0;color:#c68c4c;padding:0.25rem 0.75rem;border-radius:20px;margin:0.25rem;display:inline-block;border:1px solid #c68c4c;">${opt}</span>`).join(' ');
    }

    if (input.type === 'checkbox' && !input.checked) return;

    if (value && value.trim() !== '') {
      const p = document.createElement('p');
      p.innerHTML = `<strong>${label}:</strong> ${value}`;
      this.recapContent.appendChild(p);
    }
  });
}

  // ---------------- COMPLETE ----------------
  completeProduct() {
    this.productElement.querySelector('.estimator__form-content').style.display = 'none';
    this.fillRecap();
    if (this.recapBox) {
      this.recapBox.style.display = 'block';
    }
    this.productElement.classList.add('completed');
    this.saveData();

    checkSubmitEnable();
  }

  editProduct() {
    if (this.recapBox) {
      this.recapBox.style.display = 'none';
    }
    this.productElement.querySelector('.estimator__form-content').style.display = 'flex';
    this.currentTab = 0;
    this.showTab(0);
    this.productElement.classList.remove('completed');
    this.saveData();
    checkSubmitEnable();
    //scroll
    this.scrollToTabTop();
  }

// ---------------- GESTIONE SELEZIONE COLORI MULTIPLI ----------------
setupColorSelection() {
  const colorItems = this.productElement.querySelectorAll('.color-item-collapsible-row-2[data-colore-name]');
  const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');

  if (!colorItems.length || !hiddenInput) return;

  // Inizializza l'oggetto per memorizzare le selezioni multiple
  this.selectedColors = {};

  colorItems.forEach(item => {
    item.addEventListener('click', () => {
      const colorType = item.dataset.coloreType || 'generico';
      const colorName = item.dataset.coloreName;
      const colorCode = item.dataset.coloreCode;
      
      // Se già selezionato per questo tipo, deseleziona
      if (this.selectedColors[colorType] === colorName) {
        item.classList.remove('selected');
        delete this.selectedColors[colorType];
      } else {
        // Rimuovi selezione precedente per questo tipo
        const sameTypeItems = this.productElement.querySelectorAll(`.color-item-collapsible-row-2[data-colore-type="${colorType}"]`);
        sameTypeItems.forEach(i => i.classList.remove('selected'));
        
        // Aggiungi nuova selezione
        item.classList.add('selected');
        this.selectedColors[colorType] = colorName;
      }

      this.updateColorSelectionInput();
      this.resetLaterColorSelection();
      this.saveData();
    });
  });

  if (laterColorToggle) {
    laterColorToggle.addEventListener('click', () => {
      // Deseleziona tutti i colori
      colorItems.forEach(i => i.classList.remove('selected'));
      this.selectedColors = {};
      hiddenInput.value = 'Colori da selezionare in seguito';
      this.setLaterColorSelection();
      this.saveData();
    });
  }

  // Ripristina selezioni salvate
  this.restoreColorSelections();
}

updateColorSelectionInput() {
  const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
  if (!hiddenInput) return;

  if (!this.selectedColors || Object.keys(this.selectedColors).length === 0) {
    hiddenInput.value = '';
    return;
  }

  const selections = [];
  Object.keys(this.selectedColors).forEach(type => {
    selections.push(`${type}: ${this.selectedColors[type]}`);
  });

  hiddenInput.value = selections.join(' | ');
  console.log('Input verniciatura aggiornato:', hiddenInput.value);
}

restoreColorSelections() {
  // Questo verrà chiamato quando carichi i dati salvati
  const hiddenInput = this.productElement.querySelector(`#verniciatura-${this.index}`);
  if (!hiddenInput || !hiddenInput.value || hiddenInput.value.includes('in seguito')) return;

  // Ripristina le selezioni dall'input value
  this.selectedColors = {};
  const selections = hiddenInput.value.split(' | ');
  
  selections.forEach(selection => {
    const match = selection.match(/(.+): (.+)/);
    if (match) {
      const type = match[1].trim();
      const colorName = match[2].trim();
      this.selectedColors[type] = colorName;
      
      // Trova e seleziona l'elemento corrispondente
      const item = this.productElement.querySelector(`.color-item-collapsible-row-2[data-colore-type="${type}"][data-colore-name="${colorName}"]`);
      if (item) {
        item.classList.add('selected');
      }
    }
  });
}

setLaterColorSelection() {
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  if (!laterColorToggle) return;

  const checkmark = laterColorToggle.querySelector('.checkmark');
  const svg = checkmark.querySelector('svg');

  laterColorToggle.style.borderColor = '#c68c4c';
  laterColorToggle.style.background = '#fff8f0';
  checkmark.style.background = '#c68c4c';
  checkmark.style.borderColor = '#c68c4c';
  svg.style.opacity = '1';

  laterColorToggle.closest('.color-later-option').classList.add('color-later-selected');
}

resetLaterColorSelection() {
  const laterColorToggle = this.productElement.querySelector('.color-later-toggle[data-type="verniciatura"]');
  if (!laterColorToggle) return;

  const checkmark = laterColorToggle.querySelector('.checkmark');
  const svg = checkmark.querySelector('svg');

  laterColorToggle.style.borderColor = '#e0e0e0';
  laterColorToggle.style.background = '#f9f9f9';
  checkmark.style.background = 'transparent';
  checkmark.style.borderColor = '#ccc';
  svg.style.opacity = '0';

  laterColorToggle.closest('.color-later-option').classList.remove('color-later-selected');
}

// ---------------- CARICA DATI CONSEGNA E MONTAGGIO ----------------
loadDeliveryMontaggioData(productData) {
  const consegnaTab = this.productElement.querySelector(`[data-tab*="consegna-${this.index}"]`);
  const montaggioTab = this.productElement.querySelector(`[data-tab*="montaggio-${this.index}"]`);
  
  if (!consegnaTab && !montaggioTab) return;

  console.log('Caricamento dati consegna/montaggio per:', this.uniqueProductId);

  // Cerca i valori nei dati salvati
  let consegnaValue = null;
  let montaggioValue = null;

  Object.keys(productData.inputs).forEach(key => {
    if (key.includes('Modalita_Consegna')) {
      consegnaValue = productData.inputs[key];
      console.log('Trovato Modalita_Consegna:', consegnaValue);
    }
    if (key.includes('Servizio_Montaggio')) {
      montaggioValue = productData.inputs[key];
      console.log('Trovato Servizio_Montaggio:', montaggioValue);
    }
  });

  // RIPRISTINA CONSEGNA - USA SIMULAZIONE CLICK
  if (consegnaValue && consegnaTab) {
    const hiddenInput = consegnaTab.querySelector(`#consegna-${this.index}`);
    
    if (hiddenInput) {
      hiddenInput.value = consegnaValue;
      console.log('Input consegna impostato a:', consegnaValue);
    }
    
    // Simula il click sul pulsante corretto dopo un breve delay
    setTimeout(() => {
      this.simulateRadioButtonClick('delivery-options', consegnaValue);
    }, 100);
  }

  // RIPRISTINA MONTAGGIO - USA SIMULAZIONE CLICK
  if (montaggioValue && montaggioTab) {
    const hiddenInput = montaggioTab.querySelector(`#montaggio-${this.index}`);
    
    if (hiddenInput) {
      hiddenInput.value = montaggioValue;
      console.log('Input montaggio impostato a:', montaggioValue);
    }
    
    // Simula il click sul pulsante corretto dopo un breve delay
    setTimeout(() => {
      this.simulateRadioButtonClick('montaggio-options', montaggioValue);
    }, 150);
  }
}

// ---------------- SIMULA CLICK SU RADIO BUTTON ----------------
simulateRadioButtonClick(containerClass, valueToSelect) {
  const optionsContainer = this.productElement.querySelector(`.${containerClass}`);
  if (!optionsContainer || !valueToSelect) return;

  const options = optionsContainer.querySelectorAll('.delivery-option, .montaggio-option');
  
  options.forEach(option => {
    const optionText = option.querySelector('div > div:first-child').textContent.trim();
    
    if (optionText === valueToSelect) {
      // Simula il click sul pulsante
      option.click();
      console.log(`Simulato click su: ${optionText}`);
    }
  });
}

}

// ---------------- MEMORIA DATI CLIENTE ----------------
function saveCustomerData() {
  const customerData = {
    name: document.getElementById('name')?.value || '',
    surname: document.getElementById('surname')?.value || '',
    email: document.getElementById('email')?.value || '',
    phone: document.getElementById('phone')?.value || '',
    address: document.getElementById('address')?.value || '',
    indirizzo: document.getElementById('indirizzo')?.value || '',
    cap: document.getElementById('cap')?.value || '',
    citta: document.getElementById('citta')?.value || '',
    provincia: document.getElementById('provincia')?.value || '',
    regione: document.getElementById('regione')?.value || ''
  };
  localStorage.setItem('estimator_customer_data', JSON.stringify(customerData));
}

function loadCustomerData() {
  const saved = localStorage.getItem('estimator_customer_data');
  if (!saved) return;

  const customerData = JSON.parse(saved);
  Object.keys(customerData).forEach(field => {
    const input = document.getElementById(field);
    if (input && customerData[field]) {
      input.value = customerData[field];
    }
  });
  checkVenetoRegion(customerData.regione);
}

function clearCustomerData() {
  localStorage.removeItem('estimator_customer_data');
}

// ---------------- CLEAR CART AFTER SUCCESS ----------------
function clearCartAfterSuccess() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(response => response.json())
  .then(data => {
    console.log('Carrello svuotato con successo');
    const cartCounters = document.querySelectorAll('.cart-count-bubble');
    cartCounters.forEach(counter => {
      counter.textContent = '0';
      counter.style.display = 'none';
    });
  })
  .catch(error => {
    console.error('Errore nello svuotare il carrello:', error);
  });
}

// ---------------- DUPLICA DATI ----------------
function duplicateData(chk) {
  if (!chk.checked) return;
  const currentIndex = chk.dataset.productIndex;
  const [productIndex, unitIndex] = currentIndex.split('-').map(Number);
  const prev = document.querySelector(`.estimator__product[data-product-index="${productIndex}-${unitIndex-1}"]`);
  const cur = document.querySelector(`.estimator__product[data-product-index="${currentIndex}"]`);
  if (!prev || !cur) return;

  prev.querySelectorAll('input, select, textarea').forEach(inp => {
    const name = inp.name.replace(`[${productIndex}-${unitIndex-1}]`, `[${currentIndex}]`);
    const target = cur.querySelector(`[name="${name}"]`);
    if (!target) return;
    if (inp.type === 'checkbox') target.checked = inp.checked;
    else target.value = inp.value;
    target.dispatchEvent(new Event('change'));
  });

  const prevFiles = prev.querySelector('.file-input')?.files;
  const curFileInput = cur.querySelector('.file-input');
  if (prevFiles && curFileInput) {
    const dt = new DataTransfer();
    Array.from(prevFiles).forEach(f => dt.items.add(f));
    curFileInput.files = dt.files;
    cur.querySelector('.image-preview-container').innerHTML = '';
    new ProductEstimator(cur, currentIndex).handleFileSelection(curFileInput.files);
  }

  const prevColor = prev.querySelector('.color-item-collapsible-row-2.selected');
  if (prevColor) {
    const colorName = prevColor.querySelector('.color-name-collapsible-row-2').textContent;
    const curColors = cur.querySelectorAll('.color-item-collapsible-row-2');
    curColors.forEach(item => {
      if (item.querySelector('.color-name-collapsible-row-2').textContent === colorName) {
        item.click();
      }
    });
  }
}

// ---------------- PULIZIA DATI SALVATI ----------------
function clearAllSavedData() {
  document.querySelectorAll('.estimator__product').forEach((prod) => {
    const productIdInput = prod.querySelector('input[name*="product_id"]');
    const variantIdInput = prod.querySelector('input[name*="variant_id"]');
    
    if (productIdInput && variantIdInput) {
      const productId = productIdInput.value;
      const variantId = variantIdInput.value;
      const unitIndex = getUnitIndexForElement(prod);
      const uniqueId = `product_${productId}_variant_${variantId}_unita${unitIndex}`;
      
      localStorage.removeItem(`estimator_${uniqueId}`);
      localStorage.removeItem(`estimator_files_${uniqueId}`);
    }
  });
  
  clearCustomerData();
}

// ---------------- PULIZIA DATI OBSOLETI MIGLIORATA ----------------
function cleanupOldEstimatorData() {
  const keysToRemove = [];
  
  // Ottieni tutte le combinazioni product_id + variant_id + unità attuali nel carrello
  const currentProductUnits = new Set();
  
  document.querySelectorAll('.estimator__product').forEach(prod => {
    const productIdInput = prod.querySelector('input[name*="product_id"]');
    const variantIdInput = prod.querySelector('input[name*="variant_id"]');
    
    if (productIdInput && variantIdInput) {
      const productId = productIdInput.value;
      const variantId = variantIdInput.value;
      const unitIndex = getUnitIndexForElement(prod);
      
      // SALVA product_id + variant_id + unitIndex
      const productUnitKey = `estimator_product_${productId}_variant_${variantId}_unita${unitIndex}`;
      currentProductUnits.add(productUnitKey);
    }
  });
  
  console.log('Unità prodotto attuali nel carrello:', Array.from(currentProductUnits));
  
  // Scansiona tutto il localStorage
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    
    // Verifica solo le chiavi del nostro estimator
    if (key && (key.startsWith('estimator_') || key.startsWith('estimator_files_'))) {
      // Estrai product_id, variant_id e unitIndex dalla chiave
      const match = key.match(/estimator_(?:files_)?product_(\d+)_variant_([^_]+)_unita(\d+)$/);
      
      if (match) {
        const productId = match[1];
        const variantId = match[2];
        const unitIndex = match[3];
        const productUnitKey = `estimator_product_${productId}_variant_${variantId}_unita${unitIndex}`;
        
        // Se questa unità specifica NON è nel carrello attuale, è obsoleta
        if (!currentProductUnits.has(productUnitKey)) {
          keysToRemove.push(key);
          console.log('Trovato dato obsoleto:', key, '- Unità non più nel carrello');
        } else {
          console.log('Trovato dato valido:', key, '- Unità ancora nel carrello');
        }
      } else {
        // Se non matcha il pattern nuovo, è una chiave vecchia → cancella
        keysToRemove.push(key);
        console.log('Trovato dato obsoleto (vecchio formato):', key);
      }
    }
  }
  
  // Rimuovi solo i dati obsoleti
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
    console.log('Rimosso dato obsoleto:', key);
  });
  
  if (keysToRemove.length > 0) {
    console.log(`Puliti ${keysToRemove.length} dati obsoleti`);
  } else {
    console.log('Nessun dato obsoleto trovato');
  }
}

// ---------------- FUNZIONE HELPER PER OTTENERE L'INDICE DELL'UNITÀ ----------------
function getUnitIndexForElement(productElement) {
  const productIdInput = productElement.querySelector('input[name*="product_id"]');
  const variantIdInput = productElement.querySelector('input[name*="variant_id"]');
  
  if (!productIdInput || !variantIdInput) return 1;
  
  const productId = productIdInput.value;
  const variantId = variantIdInput.value;
  const allProducts = document.querySelectorAll('.estimator__product');
  let unitCounter = 1;
  
  // Conta quante unità dello stesso product_variant ci sono prima di questa
  for (let i = 0; i < allProducts.length; i++) {
    const prod = allProducts[i];
    const prodIdInput = prod.querySelector('input[name*="product_id"]');
    const varIdInput = prod.querySelector('input[name*="variant_id"]');
    
    if (prodIdInput && varIdInput) {
      const prodId = prodIdInput.value;
      const varId = varIdInput.value;
      
      // Se troviamo lo stesso product_variant
      if (prodId === productId && varId === variantId) {
        // Se è l'elemento corrente, restituisci il counter
        if (prod === productElement) {
          return unitCounter;
        }
        unitCounter++;
      }
    }
  }
  
  return unitCounter;
}

// ---------------- INVIO FORM AGGIORNATO ----------------
// ---------------- INVIO FORM AGGIORNATO CON SWEETALERT ----------------
document.getElementById('estimator-form')?.addEventListener('submit', async function (e) {
  e.preventDefault();

  const form = e.target;
  const submitBtn = form.querySelector('button[type="submit"]');
  submitBtn.disabled = true;
  submitBtn.textContent = 'Invio in corso...';

  try {
    const token = await grecaptcha.execute('6Lf3YtMrAAAAAIh9recTLC15OxU8ooMKaBzBOlCk', { action: 'submit' });

    const customer = {
      name: form.querySelector('#name')?.value || '',
      surname: form.querySelector('#surname')?.value || '',
      email: form.querySelector('#email')?.value || '',
      phone: form.querySelector('#phone')?.value || '',
      address: form.querySelector('#address')?.value || '',
      indirizzo: form.querySelector('#indirizzo')?.value || '',
      cap: form.querySelector('#cap')?.value || '',
      provincia: form.querySelector('#provincia')?.value || '',
      citta: form.querySelector('#citta')?.value || ''
    };

    const products = [];
    const productElements = document.querySelectorAll('.estimator__product');

    for (const [index, prodElem] of productElements.entries()) {
      const product = {};

      prodElem.querySelectorAll('input, select, textarea').forEach(input => {
        if (!input.name || input.type === 'file') return;
        const fieldName = extractFieldName(input.name);
        if (fieldName) product[fieldName] = input.value;
      });

      const productIdInput = prodElem.querySelector('input[name*="product_id"]');
      if (productIdInput) product['product_id'] = productIdInput.value;

      products.push(product);
    }

    const formData = new FormData();
    formData.append('customer', JSON.stringify(customer));
    formData.append('products', JSON.stringify(products));
    formData.append('captcha', token);

    productElements.forEach((prodElem, productIndex) => {
      const previewImages = prodElem.querySelectorAll('.image-preview-img');
      previewImages.forEach((img, imgIndex) => {
        const src = img.src;
        if (!src.startsWith('data:')) return;

        const mime = src.match(/data:(.*);base64,/)[1];
        const bstr = atob(src.split(',')[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);

        const blob = new Blob([u8arr], { type: mime });
        const filename = `product_${productIndex}_img_${imgIndex}.png`;
        formData.append(`files[${productIndex}][]`, blob, filename);
      });
    });

    const response = await fetch('https://ws.3base3.it/api/preventivo', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error('HTTP error ' + response.status + ': ' + errorText);
    }

    const result = await response.json();
    console.log('Risposta server:', result);

    if (result.success) {
      // MOSTRA SWEETALERT DI SUCCESSO
      Swal.fire({
        title: 'Preventivo Inviato!',
        html: `Il preventivo è stato ricevuto! A breve riceverai una mail di conferma. Grazie per aver scelto EuroArredo!<br><br><small>Riferimento: ${result.crm_id || 'N/A'}</small>`,
        icon: 'success',
        confirmButtonColor: '#28a745',
        confirmButtonText: 'OK',
        customClass: {
          popup: 'estimator-swal-popup',
          title: 'estimator-swal-title',
          htmlContainer: 'estimator-swal-html'
        }
      }).then(() => {
        clearAllSavedData();
        clearCartAfterSuccess();
        form.reset();
         window.location.href = '/'; // Scommenta se vuoi reindirizzare
      });
      
    } else {
      // MOSTRA SWEETALERT DI ERRORE
      Swal.fire({
        title: 'Errore',
        text: 'Si è verificato un errore. Si prega di riprovare più tardi.',
        icon: 'error',
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Riprova'
      });
      submitBtn.disabled = false;
      submitBtn.textContent = 'Invia preventivo';
    }

  } catch (err) {
    console.error('Errore completo:', err);
    // MOSTRA SWEETALERT DI ERRORE
    Swal.fire({
      title: 'Errore',
      text: 'Si è verificato un errore. Si prega di riprovare più tardi.',
      icon: 'error',
      confirmButtonColor: '#dc3545',
      confirmButtonText: 'Riprova'
    });
    submitBtn.disabled = false;
    submitBtn.textContent = 'Invia preventivo';
  }
});

function extractFieldName(fullName) {
  const match = fullName.match(/\[([^\]]+)\]$/);
  return match ? match[1] : fullName;
}

function checkSubmitEnable() {
  const form = document.getElementById('estimator-form');
  const allCompleted = [...document.querySelectorAll('.estimator__product')].every(p => p.classList.contains('completed'));
  const submit = form.querySelector('button[type="submit"]');
  submit.disabled = !allCompleted;

  document.querySelector('.customer-info-form').style.display = allCompleted ? 'grid' : 'none';
}

// ---------------- GESTIONE MISURE MULTIPLE ----------------

// SETUP GESTIONE MISURE
function setupMeasuresManagement() {
  // Pulsante "Aggiungi un altro prodotto"
  document.querySelectorAll('.add-another-product').forEach(btn => {
    btn.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      addAnotherProduct(variantId);
    });
  });

  // Pulsante "Rimuovi"
  document.querySelectorAll('.remove-unit').forEach(btn => {
    btn.addEventListener('click', function() {
      const productIndex = this.dataset.productIndex;
      removeUnit(productIndex);
    });
  });
}

//aggiungi unita
function addAnotherProduct(variantId) {
  if (!variantId) return;

  Swal.fire({
    title: 'Aggiungi prodotto',
    text: 'Vuoi aggiungere un altro prodotto identico al carrello?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#c68c4c',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Sì, aggiungi',
    cancelButtonText: 'Annulla'
  }).then((result) => {
    if (result.isConfirmed) {
      // Mostra loading
      Swal.fire({
        title: 'Aggiunta in corso...',
        text: 'Stiamo aggiungendo il prodotto al carrello',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Ricarica direttamente senza mostrare altro modal
        window.location.reload();
      })
      .catch(error => {
        console.error('Errore aggiunta prodotto:', error);
        Swal.fire({
          title: 'Errore',
          text: 'Errore nell\'aggiungere il prodotto al carrello',
          icon: 'error',
          confirmButtonColor: '#dc3545'
        });
      });
    }
  });
}

function removeUnit(productIndex) {
  Swal.fire({
    title: 'Rimuovi unità',
    text: 'Sei sicuro di voler rimuovere questa unità?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Sì, rimuovi',
    cancelButtonText: 'Annulla'
  }).then((result) => {
    if (result.isConfirmed) {
      const productElement = document.querySelector(`.estimator__product[data-product-index="${productIndex}"]`);
      if (!productElement) {
        Swal.fire({
          title: 'Errore',
          text: 'Prodotto non trovato',
          icon: 'error',
          confirmButtonColor: '#dc3545'
        });
        return;
      }

      // Mostra loading
      Swal.fire({
        title: 'Rimozione in corso...',
        text: 'Stiamo rimuovendo l\'unità dal carrello',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const [lineNumber, quantityIndex] = productIndex.split('-').map(Number);
      const quantityToRemove = 1;

      // Pulisci localStorage
      const productIdInput = productElement.querySelector('input[name*="product_id"]');
      const productId = productIdInput ? productIdInput.value : 'unknown';
      const uniqueId = `product_${productId}_line_${lineNumber}_unita${quantityIndex}`;
      localStorage.removeItem(`estimator_${uniqueId}`);
      localStorage.removeItem(`estimator_files_${uniqueId}`);

      // Rimuovi dal carrello
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: lineNumber + 1,
          quantity: quantityIndex - quantityToRemove
        })
      })
      .then(response => response.json())
      .then(data => {
        // Ricarica direttamente senza mostrare altro modal
        window.location.reload();
      })
      .catch(error => {
        console.error('Errore rimozione unità:', error);
        Swal.fire({
          title: 'Errore',
          text: 'Errore nella rimozione dell\'unità',
          icon: 'error',
          confirmButtonColor: '#dc3545'
        });
      });
    }
  });
}
// ---------------- INIT MIGLIORATO ----------------
document.addEventListener('DOMContentLoaded', function() {
  console.log('=== INIZIALIZZAZIONE PRODUCT ESTIMATOR ===');
  
  // PRIMA pulisci i dati obsoleti
  cleanupOldEstimatorData();
  
  // POI inizializza i prodotti
  document.querySelectorAll('.estimator__product').forEach((p, i) => {
    console.log('Inizializzazione prodotto:', p.dataset.productIndex);
    new ProductEstimator(p, p.dataset.productIndex);
  });

  // Setup gestione misure e quantità
  setupMeasuresManagement();

  loadCustomerData();

  document.querySelectorAll('.customer-info-form input').forEach(input => {
    input.addEventListener('input', saveCustomerData);
    input.addEventListener('change', saveCustomerData);
  });

  document.querySelectorAll('.same-data').forEach(chk => {
    chk.addEventListener('change', () => duplicateData(chk));
  });

  if (document.getElementById('address')) {
    // Attached unconditionally, independent of whether Google Maps ever
    // loads: fail-closed instead of fail-open. Previously this listener
    // only got attached from inside initAutocomplete(), which only runs
    // if Google's script successfully loads and calls back — if it was
    // blocked, slow, or the key failed, the form submitted with whatever
    // raw text was typed, with no validation and no address splitting.
    setupAddressValidation();

    const script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCpNPN8UgY-DmxEqtHOH_bDulGH6M3LcpI&libraries=places&callback=initAutocomplete";
    script.async = true;
    script.defer = true;
    script.onerror = function () {
      window.__googleMapsFailed = true;
      const addressInput = document.getElementById('address');
      if (addressInput) {
        addressInput.placeholder = 'Servizio indirizzi non disponibile: ricarica la pagina';
      }
    };
    document.head.appendChild(script);
  }
});

// ---------------- GOOGLE AUTOCOMPLETE CON CAMPI NASCOSTI ----------------
function initAutocomplete() {
  const addressInput = document.getElementById('address');
  if (!addressInput) return;

  createHiddenAddressFields();

  const autocomplete = new google.maps.places.Autocomplete(addressInput, {
    types: ["geocode"],
    componentRestrictions: { country: "it" }
  });

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (!place.address_components) {
      console.error("Nessun dato dell'indirizzo trovato");
      return;
    }

    const addressComponents = extractAddressComponents(place.address_components);

    document.getElementById('indirizzo').value = addressComponents.street || '';
    document.getElementById('cap').value = addressComponents.postalCode || '';
    document.getElementById('citta').value = addressComponents.city || '';
    document.getElementById('provincia').value = addressComponents.province || '';
    document.getElementById('regione').value = addressComponents.region || '';

    checkVenetoRegion(addressComponents.region);

    console.log("Indirizzo processato:", addressComponents);

    saveCustomerData();
  });

  window.__googleMapsFailed = false;
}

function createHiddenAddressFields() {
  const addressContainer = document.getElementById('address').closest('.form-group');
  if (!addressContainer) return;

  if (!document.getElementById('indirizzo')) {
    const hiddenFields = [
      { id: 'indirizzo', name: 'customer[indirizzo]' },
      { id: 'cap', name: 'customer[cap]' },
      { id: 'provincia', name: 'customer[provincia]' },
      { id: 'citta', name: 'customer[citta]' },
      { id: 'regione', name: 'customer[regione]' }
    ];

    hiddenFields.forEach(field => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.id = field.id;
      input.name = field.name;
      addressContainer.appendChild(input);
    });
  }
}

function extractAddressComponents(components) {
  const result = {
    street: '',
    streetNumber: '',
    postalCode: '',
    city: '',
    province: '',
    region: ''
  };

  components.forEach(component => {
    const types = component.types;

    if (types.includes('street_number')) {
      result.streetNumber = component.long_name;
    } else if (types.includes('route')) {
      result.street = component.long_name;
    } else if (types.includes('postal_code')) {
      result.postalCode = component.long_name;
    } else if (types.includes('locality')) {
      result.city = component.long_name;
    } else if (types.includes('administrative_area_level_3')) {
      if (!result.city) {
        result.city = component.long_name;
      }
    } else if (types.includes('administrative_area_level_2')) {
      result.province = component.short_name;
    } else if (types.includes('administrative_area_level_1')) {
      result.region = component.long_name;
      if (!result.province) {
        result.province = component.short_name;
      }
    } else if (types.includes('postal_town')) {
      if (!result.city) {
        result.city = component.long_name;
      }
    }
  });

  if (result.street && result.streetNumber) {
    result.street = `${result.street}, ${result.streetNumber}`;
  } else if (result.streetNumber && !result.street) {
    result.street = result.streetNumber;
  }

  console.log("Componenti estratti:", result);
  console.log("Tutti i componenti:", components);

  return result;
}

// ---------------- FUORI REGIONE VENETO ----------------
function checkVenetoRegion(region) {
  const notice = document.getElementById('outside-veneto-notice');
  if (!notice) return;

  const isVeneto = (region || '').trim().toLowerCase() === 'veneto';
  notice.style.display = isVeneto ? 'none' : 'block';

  if (isVeneto) {
    const transportField = document.getElementById('needs_transport');
    if (transportField) transportField.checked = false;
  }
}

// ---------------- VALIDAZIONE INDIRIZZO (fail-closed) ----------------
function setupAddressValidation() {
  const addressInput = document.getElementById('address');
  if (!addressInput) return;

  let originalValue = addressInput.value;

  addressInput.addEventListener('focus', () => {
    originalValue = addressInput.value;
  });

  addressInput.addEventListener('input', (e) => {
    if (e.target.value !== originalValue) {
      ['indirizzo', 'cap', 'citta', 'provincia', 'regione'].forEach((id) => {
        const field = document.getElementById(id);
        if (field) field.value = '';
      });
      const notice = document.getElementById('outside-veneto-notice');
      if (notice) notice.style.display = 'none';
    }
  });

  const form = document.getElementById('estimator-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (!isValidGoogleAddressSelected()) {
        e.preventDefault();
        if (window.__googleMapsFailed) {
          alert('Il servizio di verifica indirizzo non è al momento disponibile. Ricarica la pagina e riprova, oppure contattaci direttamente.');
        } else {
          alert('Per favore, seleziona un indirizzo valido dalla lista di Google Maps.');
        }
        addressInput.focus();
      }
    });
  }
}

function isValidGoogleAddressSelected() {
  const indirizzo = document.getElementById('indirizzo')?.value;
  const cap = document.getElementById('cap')?.value;
  const citta = document.getElementById('citta')?.value;
  const provincia = document.getElementById('provincia')?.value;

  return !!(indirizzo || cap || citta || provincia);
}